import { n as e, t } from "./BlockNoteExtension-B6RhuQ3V.js";
import { DOMParser as n, Fragment as r, Slice as i } from "prosemirror-model";
import { Mapping as a, ReplaceStep as o } from "prosemirror-transform";
import { Extension as s, InputRule as c, Mark as l, Node as u, callOrReturn as d, combineTransactionSteps as f, findChildrenInRange as p, findParentNode as m, getChangedRanges as h, getExtensionField as g, markInputRule as _, mergeAttributes as v } from "@tiptap/core";
import { Plugin as y, PluginKey as ee, TextSelection as te } from "prosemirror-state";
import { uuidv4 as ne } from "lib0/random";
import { DOMParser as re, DOMSerializer as ie, Fragment as ae } from "@tiptap/pm/model";
import { CellSelection as oe, TableMap as se, TableView as ce, columnResizing as le, goToNextCell as ue, isInTable as de, moveCellForward as fe, nextCell as pe, selectionCell as me, tableEditing as he } from "prosemirror-tables";
import { createHighlightPlugin as ge } from "prosemirror-highlight";
import { createParser as _e } from "prosemirror-highlight/shiki";
import { Plugin as ve, PluginKey as ye } from "@tiptap/pm/state";
import { Decoration as be, DecorationSet as xe } from "@tiptap/pm/view";
import { Decoration as Se, DecorationSet as Ce } from "prosemirror-view";
import { absolutePositionToRelativePosition as we, relativePositionToAbsolutePosition as Te, ySyncPluginKey as Ee } from "y-prosemirror";
import De from "@tiptap/extension-bold";
import Oe from "@tiptap/extension-code";
import ke from "@tiptap/extension-italic";
import Ae from "@tiptap/extension-strike";
import je from "@tiptap/extension-underline";
//#region src/extensions/tiptap-extensions/UniqueID/UniqueID.ts
function Me(e, t = JSON.stringify) {
	let n = {};
	return e.filter((e) => {
		let r = t(e);
		return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
	});
}
function Ne(e) {
	return Me(e.filter((t, n) => e.indexOf(t) !== n));
}
var Pe = s.create({
	name: "uniqueID",
	priority: 1e4,
	addOptions() {
		return {
			attributeName: "id",
			types: [],
			setIdAttribute: !1,
			isWithinEditor: void 0,
			generateID: () => {
				if (typeof window < "u" && window.__TEST_OPTIONS) {
					let e = window.__TEST_OPTIONS;
					return e.mockID === void 0 ? e.mockID = 0 : e.mockID++, e.mockID.toString();
				}
				return ne();
			},
			filterTransaction: null
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { [this.options.attributeName]: {
				default: null,
				parseHTML: (e) => e.getAttribute(`data-${this.options.attributeName}`),
				renderHTML: (e) => {
					let t = { [`data-${this.options.attributeName}`]: e[this.options.attributeName] };
					return this.options.setIdAttribute ? {
						...t,
						id: e[this.options.attributeName]
					} : t;
				}
			} }
		}];
	},
	addProseMirrorPlugins() {
		let { isWithinEditor: e } = this.options, t = null, n = !1;
		return [new y({
			key: new ee("uniqueID"),
			appendTransaction: (e, t, n) => {
				let r = e.some((e) => e.docChanged) && !t.doc.eq(n.doc), i = this.options.filterTransaction && e.some((e) => !this.options.filterTransaction?.(e));
				if (!r || i) return;
				let { tr: a } = n, { types: o, attributeName: s, generateID: c } = this.options, l = f(t.doc, e), { mapping: u } = l;
				if (h(l).forEach(({ newRange: e }) => {
					let r = p(n.doc, e, (e) => o.includes(e.type.name)), i = Ne(r.map(({ node: e }) => e.attrs[s]).filter((e) => e !== null));
					r.forEach(({ node: e, pos: r }) => {
						let o = a.doc.nodeAt(r)?.attrs[s];
						if (o === null) {
							let i = t.doc.type.createAndFill().content;
							if (t.doc.content.findDiffStart(i) === null) {
								let t = JSON.parse(JSON.stringify(n.doc.toJSON()));
								if (t.content[0].content[0].attrs.id = "initialBlockId", JSON.stringify(t.content) === JSON.stringify(i.toJSON())) {
									a.setNodeMarkup(r, void 0, {
										...e.attrs,
										[s]: "initialBlockId"
									});
									return;
								}
							}
							a.setNodeMarkup(r, void 0, {
								...e.attrs,
								[s]: c()
							});
							return;
						}
						let { deleted: l } = u.invert().mapResult(r);
						l && i.includes(o) && a.setNodeMarkup(r, void 0, {
							...e.attrs,
							[s]: c()
						});
					});
				}), a.steps.length) return a.setMeta("uniqueID", !0), a;
			},
			view(n) {
				let r = (r) => {
					let i = n.dom.parentElement;
					t = i?.contains(r.target) || e?.(r.target) ? i : null;
				};
				return window.addEventListener("dragstart", r), { destroy() {
					window.removeEventListener("dragstart", r);
				} };
			},
			props: {
				handleDOMEvents: {
					drop: (e, r) => (n = t !== e.dom.parentElement || r.dataTransfer?.effectAllowed === "copy", t = null, !1),
					paste: () => (n = !0, !1)
				},
				transformPasted: (e) => {
					if (!n) return e;
					let { types: t, attributeName: a } = this.options, o = (e) => {
						let n = [];
						return e.forEach((e) => {
							if (e.isText) {
								n.push(e);
								return;
							}
							if (!t.includes(e.type.name)) {
								n.push(e.copy(o(e.content)));
								return;
							}
							let r = e.type.create({
								...e.attrs,
								[a]: null
							}, o(e.content), e.marks);
							n.push(r);
						}), r.from(n);
					};
					return n = !1, new i(o(e.content), e.openStart, e.openEnd);
				}
			}
		})];
	}
});
//#endregion
//#region src/schema/inlineContent/types.ts
function Fe(e) {
	return e.type === "link";
}
function Ie(e) {
	return typeof e != "string" && e.type === "link";
}
function b(e) {
	return typeof e != "string" && e.type === "text";
}
//#endregion
//#region src/util/table.ts
function x(e) {
	return C(e) ? { ...e } : S(e) ? {
		type: "tableCell",
		content: [].concat(e.content),
		props: {
			backgroundColor: e.props?.backgroundColor ?? "default",
			textColor: e.props?.textColor ?? "default",
			textAlignment: e.props?.textAlignment ?? "left",
			colspan: e.props?.colspan ?? 1,
			rowspan: e.props?.rowspan ?? 1
		}
	} : {
		type: "tableCell",
		content: [].concat(e),
		props: {
			backgroundColor: "default",
			textColor: "default",
			textAlignment: "left",
			colspan: 1,
			rowspan: 1
		}
	};
}
function S(e) {
	return e != null && typeof e != "string" && !Array.isArray(e) && e.type === "tableCell";
}
function C(e) {
	return S(e) && e.props !== void 0 && e.content !== void 0;
}
function w(e) {
	return C(e) ? e.props.colspan ?? 1 : 1;
}
function Le(e) {
	return C(e) ? e.props.rowspan ?? 1 : 1;
}
//#endregion
//#region src/util/typescript.ts
var T = class extends Error {
	constructor(e) {
		super(`Unreachable case: ${e}`);
	}
};
function Re(e, t = !0) {
	let { "data-test": n, ...r } = e;
	if (Object.keys(r).length > 0 && t) throw Error("Object must be empty " + JSON.stringify(e));
}
//#endregion
//#region src/util/browser.ts
var ze = () => typeof navigator < "u" && (/Mac/.test(navigator.platform) || /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent));
function E(e, t = "Ctrl") {
	return ze() ? e.replace("Mod", "⌘") : e.replace("Mod", t);
}
function D(...e) {
	return [...new Set(e.filter((e) => e).join(" ").split(" "))].join(" ");
}
var Be = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//#endregion
//#region src/blocks/defaultBlockHelpers.ts
function Ve(e, t, n, r) {
	let i = document.createElement("div");
	i.className = D("bn-block-content", n.class), i.setAttribute("data-content-type", e);
	for (let [e, t] of Object.entries(n)) e !== "class" && i.setAttribute(e, t);
	let a = document.createElement(t);
	a.className = D("bn-inline-content", r.class);
	for (let [e, t] of Object.entries(r)) e !== "class" && a.setAttribute(e, t);
	return i.appendChild(a), {
		dom: i,
		contentDOM: a
	};
}
var He = (e, t) => {
	let n = W(e, t.pmSchema);
	n.type.name === "blockContainer" && (n = n.firstChild);
	let r = t.pmSchema.nodes[n.type.name].spec.toDOM;
	if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
	let i = r(n);
	if (typeof i != "object" || !("dom" in i)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap node's `renderHTML` function does not return an object with the `dom` property.");
	return i;
};
function Ue(e, t = "<br>") {
	let n = e.querySelectorAll("p");
	if (n.length > 1) {
		let e = n[0];
		for (let r = 1; r < n.length; r++) {
			let i = n[r];
			e.innerHTML += t + i.innerHTML, i.remove();
		}
	}
}
//#endregion
//#region src/util/string.ts
function O(e) {
	return "data-" + e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function We(e) {
	let t = e.split("/");
	return !t.length || t[t.length - 1] === "" ? e : t[t.length - 1];
}
function Ge(e) {
	let t = [
		"mp4",
		"webm",
		"ogg",
		"mov",
		"mkv",
		"flv",
		"avi",
		"wmv",
		"m4v"
	];
	try {
		let n = new URL(e).pathname.split(".").pop()?.toLowerCase() || "";
		return t.includes(n);
	} catch {
		return !1;
	}
}
//#endregion
//#region src/schema/blocks/internal.ts
function Ke(e) {
	let t = {};
	return Object.entries(e).forEach(([e, n]) => {
		t[e] = {
			default: n.default,
			keepOnSplit: !0,
			parseHTML: (t) => {
				let r = t.getAttribute(O(e));
				if (r === null) return null;
				if (n.default === void 0 && n.type === "boolean" || n.default !== void 0 && typeof n.default == "boolean") return r === "true" ? !0 : r === "false" ? !1 : null;
				if (n.default === void 0 && n.type === "number" || n.default !== void 0 && typeof n.default == "number") {
					let e = parseFloat(r);
					return !Number.isNaN(e) && Number.isFinite(e) ? e : null;
				}
				return r;
			},
			renderHTML: (t) => t[e] === n.default ? {} : { [O(e)]: t[e] }
		};
	}), t;
}
function qe(e, t, n, r) {
	let i = e();
	if (i === void 0) throw Error("Cannot find node position");
	let a = n.state.doc.resolve(i).node().attrs.id;
	if (!a) throw Error("Block doesn't have id");
	let o = t.getBlock(a);
	if (o.type !== r) throw Error("Block type does not match");
	return o;
}
function k(e, t, n, r, i = !1, a) {
	let o = document.createElement("div");
	if (a !== void 0) for (let [e, t] of Object.entries(a)) e !== "class" && o.setAttribute(e, t);
	o.className = D("bn-block-content", a?.class || ""), o.setAttribute("data-content-type", t);
	for (let [e, t] of Object.entries(n)) t !== r[e].default && o.setAttribute(O(e), t);
	return i && o.setAttribute("data-file-block", ""), o.appendChild(e.dom), e.contentDOM && (e.contentDOM.className = D("bn-inline-content", e.contentDOM.className)), {
		...e,
		dom: o
	};
}
function Je(e, t, n) {
	return {
		config: {
			type: e.type,
			content: e.content,
			propSchema: t
		},
		implementation: {
			node: e.node,
			render: He,
			toExternalHTML: He
		},
		extensions: n
	};
}
//#endregion
//#region src/schema/blocks/createSpec.ts
function Ye(e, t) {
	e.stopEvent = (e) => (e.type === "mousedown" && setTimeout(() => {
		t.view.dom.blur();
	}, 10), !0);
}
function Xe(e, t) {
	let n = [{
		tag: "[data-content-type=" + e.type + "]",
		contentElement: ".bn-inline-content"
	}];
	return t.parse && n.push({
		tag: "*",
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t.parse?.(e);
			return n === void 0 ? !1 : n;
		},
		preserveWhitespace: !0,
		getContent: e.content === "inline" || e.content === "none" ? (n, r) => {
			if (t.parseContent) {
				let e = t.parseContent({
					el: n,
					schema: r
				});
				if (e !== void 0) return e;
			}
			if (e.content === "inline") {
				let e = n.cloneNode(!0);
				return Ue(e, t.meta?.code ? "\n" : "<br>"), re.fromSchema(r).parse(e, {
					topNode: r.nodes.paragraph.create(),
					preserveWhitespace: !0
				}).content;
			}
			return ae.empty;
		} : void 0
	}), n;
}
function Ze(e, t, n, r) {
	let i = t.node || u.create({
		name: e.type,
		content: e.content === "inline" ? "inline*" : e.content === "none" ? "" : e.content,
		group: "blockContent",
		selectable: t.meta?.selectable ?? !0,
		isolating: t.meta?.isolating ?? !0,
		code: t.meta?.code ?? !1,
		defining: t.meta?.defining ?? !0,
		priority: r,
		addAttributes() {
			return Ke(e.propSchema);
		},
		parseHTML() {
			return Xe(e, t);
		},
		renderHTML({ HTMLAttributes: n }) {
			let r = document.createElement("div");
			return k({
				dom: r,
				contentDOM: e.content === "inline" ? r : void 0
			}, e.type, {}, e.propSchema, t.meta?.fileBlockAccept !== void 0, n);
		},
		addNodeView() {
			return (n) => {
				let r = this.options.editor, i = qe(n.getPos, r, this.editor, e.type), a = this.options.domAttributes?.blockContent || {}, o = t.render.call({
					blockContentDOMAttributes: a,
					props: n,
					renderType: "nodeView"
				}, i, r);
				return t.meta?.selectable === !1 && Ye(o, this.editor), o;
			};
		}
	});
	if (i.name !== e.type) throw Error("Node name does not match block type. This is a bug in BlockNote.");
	return {
		config: e,
		implementation: {
			...t,
			node: i,
			render(e, n) {
				let r = i.options.domAttributes?.blockContent || {};
				return t.render.call({
					blockContentDOMAttributes: r,
					props: void 0,
					renderType: "dom"
				}, e, n);
			},
			toExternalHTML: (e, n, r) => {
				let a = i.options.domAttributes?.blockContent || {};
				return t.toExternalHTML?.call({ blockContentDOMAttributes: a }, e, n, r) ?? t.render.call({
					blockContentDOMAttributes: a,
					renderType: "dom",
					props: void 0
				}, e, n);
			}
		},
		extensions: n
	};
}
function A(e) {
	return e;
}
function j(e, t, n) {
	return (r = {}) => {
		let i = typeof e == "function" ? e(r) : e, a = typeof t == "function" ? t(r) : t, o = n ? typeof n == "function" ? n(r) : n : void 0;
		return {
			config: i,
			implementation: {
				...a,
				toExternalHTML(e, t, n) {
					let r = a.toExternalHTML?.call({ blockContentDOMAttributes: this.blockContentDOMAttributes }, e, t, n);
					if (r !== void 0) return k(r, e.type, e.props, i.propSchema, a.meta?.fileBlockAccept !== void 0);
				},
				render(e, t) {
					return k(a.render.call({
						blockContentDOMAttributes: this.blockContentDOMAttributes,
						renderType: this.renderType,
						props: this.props
					}, e, t), e.type, e.props, i.propSchema, a.meta?.fileBlockAccept !== void 0, this.blockContentDOMAttributes);
				}
			},
			extensions: o
		};
	};
}
//#endregion
//#region src/api/getBlockInfoFromPos.ts
function M(e, t) {
	let n = e.resolve(t);
	if (n.nodeAfter && n.nodeAfter.type.isInGroup("bnBlock")) return {
		posBeforeNode: n.pos,
		node: n.nodeAfter
	};
	let r = n.depth, i = n.node(r);
	for (; r > 0;) {
		if (i.type.isInGroup("bnBlock")) return {
			posBeforeNode: n.before(r),
			node: i
		};
		r--, i = n.node(r);
	}
	let a = [];
	e.descendants((e, t) => {
		e.type.isInGroup("bnBlock") && a.push(t);
	}), console.warn(`Position ${t} is not within a blockContainer node.`);
	let o = e.resolve(a.find((e) => e >= t) || a[a.length - 1]);
	return {
		posBeforeNode: o.pos,
		node: o.nodeAfter
	};
}
function Qe(e, t) {
	if (!e.type.isInGroup("bnBlock")) throw Error(`Attempted to get bnBlock node at position but found node of different type ${e.type.name}`);
	let n = e, r = t, i = {
		node: n,
		beforePos: r,
		afterPos: r + n.nodeSize
	};
	if (n.type.name === "blockContainer") {
		let e, t;
		if (n.forEach((n, i) => {
			if (n.type.spec.group === "blockContent") {
				let t = n, a = r + i + 1;
				e = {
					node: t,
					beforePos: a,
					afterPos: a + n.nodeSize
				};
			} else if (n.type.name === "blockGroup") {
				let e = n, a = r + i + 1;
				t = {
					node: e,
					beforePos: a,
					afterPos: a + n.nodeSize
				};
			}
		}), !e) throw Error(`blockContainer node does not contain a blockContent node in its children: ${n}`);
		return {
			isBlockContainer: !0,
			bnBlock: i,
			blockContent: e,
			childContainer: t,
			blockNoteType: e.node.type.name
		};
	} else {
		if (!i.node.type.isInGroup("childContainer")) throw Error(`bnBlock node is not in the childContainer group: ${i.node}`);
		return {
			isBlockContainer: !1,
			bnBlock: i,
			childContainer: i,
			blockNoteType: i.node.type.name
		};
	}
}
function N(e) {
	return Qe(e.node, e.posBeforeNode);
}
function $e(e) {
	if (!e.nodeAfter) throw Error(`Attempted to get blockContainer node at position ${e.pos} but a node at this position does not exist`);
	return Qe(e.nodeAfter, e.pos);
}
function et(e) {
	return N(M(e.doc, e.selection.anchor));
}
function tt(e) {
	return N(M(e.doc, e.selection.anchor));
}
//#endregion
//#region src/api/pmUtil.ts
function P(e) {
	return "doc" in e ? e.doc.type.schema : e.type.schema;
}
function nt(e) {
	return e.cached.blockNoteEditor;
}
function rt(e) {
	return nt(e).schema;
}
function it(e) {
	return rt(e).blockSchema;
}
function at(e) {
	return rt(e).inlineContentSchema;
}
function F(e) {
	return rt(e).styleSchema;
}
function ot(e) {
	return nt(e).blockCache;
}
//#endregion
//#region src/api/nodeConversions/nodeToBlock.ts
function st(e, t, n) {
	let r = {
		type: "tableContent",
		columnWidths: [],
		headerRows: void 0,
		headerCols: void 0,
		rows: []
	}, i = [];
	e.content.forEach((e, a, o) => {
		let s = { cells: [] };
		o === 0 && e.content.forEach((e) => {
			let t = e.attrs.colwidth;
			t ??= Array(e.attrs.colspan ?? 1).fill(void 0), r.columnWidths.push(...t);
		}), s.cells = e.content.content.map((e, r) => (i[o] || (i[o] = []), i[o][r] = e.type.name === "tableHeader", {
			type: "tableCell",
			content: e.content.content.map((e) => I(e, t, n)).reduce((e, t) => {
				if (!e.length) return t;
				let n = e[e.length - 1], r = t[0];
				return r && b(n) && b(r) && JSON.stringify(n.styles) === JSON.stringify(r.styles) ? (n.text += "\n" + r.text, e.push(...t.slice(1)), e) : (e.push(...t), e);
			}, []),
			props: {
				colspan: e.attrs.colspan,
				rowspan: e.attrs.rowspan,
				backgroundColor: e.attrs.backgroundColor,
				textColor: e.attrs.textColor,
				textAlignment: e.attrs.textAlignment
			}
		})), r.rows.push(s);
	});
	for (let e = 0; e < i.length; e++) i[e]?.every((e) => e) && (r.headerRows = (r.headerRows ?? 0) + 1);
	for (let e = 0; e < i[0]?.length; e++) i?.every((t) => t[e]) && (r.headerCols = (r.headerCols ?? 0) + 1);
	return r;
}
function I(e, t, n) {
	let r = [], i;
	return e.content.forEach((e) => {
		if (e.type.name === "hardBreak") {
			if (i) if (b(i)) i.text += "\n";
			else if (Fe(i)) i.content[i.content.length - 1].text += "\n";
			else throw Error("unexpected");
			else i = {
				type: "text",
				text: "\n",
				styles: {}
			};
			return;
		}
		if (e.type.name !== "link" && e.type.name !== "text") {
			if (!t[e.type.name]) {
				console.warn("unrecognized inline content type", e.type.name);
				return;
			}
			i &&= (r.push(i), void 0), r.push(ct(e, t, n));
			return;
		}
		let a = {}, o;
		for (let t of e.marks) if (t.type.name === "link") o = t;
		else {
			let e = n[t.type.name];
			if (!e) {
				if (t.type.spec.blocknoteIgnore) continue;
				throw Error(`style ${t.type.name} not found in styleSchema`);
			}
			if (e.propSchema === "boolean") a[e.type] = !0;
			else if (e.propSchema === "string") a[e.type] = t.attrs.stringValue;
			else throw new T(e.propSchema);
		}
		i ? b(i) ? o ? (r.push(i), i = {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		}) : JSON.stringify(i.styles) === JSON.stringify(a) ? i.text += e.textContent : (r.push(i), i = {
			type: "text",
			text: e.textContent,
			styles: a
		}) : Fe(i) && (o ? i.href === o.attrs.href ? JSON.stringify(i.content[i.content.length - 1].styles) === JSON.stringify(a) ? i.content[i.content.length - 1].text += e.textContent : i.content.push({
			type: "text",
			text: e.textContent,
			styles: a
		}) : (r.push(i), i = {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		}) : (r.push(i), i = {
			type: "text",
			text: e.textContent,
			styles: a
		})) : i = o ? {
			type: "link",
			href: o.attrs.href,
			content: [{
				type: "text",
				text: e.textContent,
				styles: a
			}]
		} : {
			type: "text",
			text: e.textContent,
			styles: a
		};
	}), i && r.push(i), r;
}
function ct(e, t, n) {
	if (e.type.name === "text" || e.type.name === "link") throw Error("unexpected");
	let r = {}, i = t[e.type.name];
	for (let [t, n] of Object.entries(e.attrs)) {
		if (!i) throw Error("ic node is of an unrecognized type: " + e.type.name);
		t in i.propSchema && (r[t] = n);
	}
	let a;
	return a = i.content === "styled" ? I(e, t, n) : void 0, {
		type: e.type.name,
		props: r,
		content: a
	};
}
function L(e, t, n = it(t), r = at(t), i = F(t), a = ot(t)) {
	if (!e.type.isInGroup("bnBlock")) throw Error("Node should be a bnBlock, but is instead: " + e.type.name);
	let o = a?.get(e);
	if (o) return o;
	let s = Qe(e, 0), c = s.bnBlock.node.attrs.id;
	c === null && (c = Pe.options.generateID());
	let l = n[s.blockNoteType];
	if (!l) throw Error("Block is of an unrecognized type: " + s.blockNoteType);
	let u = {};
	for (let [t, n] of Object.entries({
		...e.attrs,
		...s.isBlockContainer ? s.blockContent.node.attrs : {}
	})) {
		let e = l.propSchema;
		t in e && !(e[t].default === void 0 && n === void 0) && (u[t] = n);
	}
	let d = n[s.blockNoteType], f = [];
	s.childContainer?.node.forEach((e) => {
		f.push(L(e, t, n, r, i, a));
	});
	let p;
	if (d.content === "inline") {
		if (!s.isBlockContainer) throw Error("impossible");
		p = I(s.blockContent.node, r, i);
	} else if (d.content === "table") {
		if (!s.isBlockContainer) throw Error("impossible");
		p = st(s.blockContent.node, r, i);
	} else if (d.content === "none") p = void 0;
	else throw new T(d.content);
	let m = {
		id: c,
		type: d.type,
		props: u,
		content: p,
		children: f
	};
	return a?.set(e, m), m;
}
function lt(e, t = P(e), n = it(t), r = at(t), i = F(t), a = ot(t)) {
	let o = [];
	return e.firstChild && e.firstChild.descendants((e) => (o.push(L(e, t, n, r, i, a)), !1)), o;
}
function ut(e, t, n = it(t), r = at(t), i = F(t), a = ot(t)) {
	function o(e, s, c) {
		if (e.type.name !== "blockGroup") throw Error("unexpected");
		let l = [], u, d;
		return e.forEach((f, p, m) => {
			if (f.type.name !== "blockContainer") throw Error("unexpected");
			if (f.childCount === 0) return;
			if (f.childCount === 0 || f.childCount > 2) throw Error("unexpected, blockContainer.childCount: " + f.childCount);
			let h = m === 0, g = m === e.childCount - 1;
			if (f.firstChild.type.name === "blockGroup") {
				if (!h) throw Error("unexpected");
				let e = o(f.firstChild, Math.max(0, s - 1), g ? Math.max(0, c - 1) : 0);
				u = e.blockCutAtStart, g && (d = e.blockCutAtEnd), l.push(...e.blocks);
				return;
			}
			let _ = L(f, t, n, r, i, a), v = f.childCount > 1 ? f.child(1) : void 0, y = [];
			if (v) {
				let e = o(v, 0, g ? Math.max(0, c - 1) : 0);
				y = e.blocks, g && (d = e.blockCutAtEnd);
			}
			g && !v && c > 1 && (d = _.id), h && s > 1 && (u = _.id), l.push({
				..._,
				children: y
			});
		}), {
			blocks: l,
			blockCutAtStart: u,
			blockCutAtEnd: d
		};
	}
	if (e.content.childCount === 0) return {
		blocks: [],
		blockCutAtStart: void 0,
		blockCutAtEnd: void 0
	};
	if (e.content.childCount !== 1) throw Error("slice must be a single block, did you forget includeParents=true?");
	return o(e.content.firstChild, Math.max(e.openStart - 1, 0), Math.max(e.openEnd - 1, 0));
}
//#endregion
//#region src/schema/inlineContent/internal.ts
function dt(e, t, n, r) {
	return e.dom.setAttribute("data-inline-content-type", t), Object.entries(n).filter(([e, t]) => t !== r[e].default).map(([e, t]) => [O(e), t]).forEach(([t, n]) => e.dom.setAttribute(t, n)), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function ft(e) {
	return { Backspace: ({ editor: t }) => {
		let n = t.state.selection.$from;
		return t.state.selection.empty && n.node().type.name === e.type && n.parentOffset === 0;
	} };
}
function pt(e, t) {
	return {
		config: e,
		implementation: t
	};
}
function mt(e, t, n) {
	return pt({
		type: e.name,
		propSchema: t,
		content: e.config.content === "inline*" ? "styled" : "none"
	}, {
		...n,
		node: e
	});
}
function ht(e) {
	return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t.config]));
}
//#endregion
//#region src/schema/styles/internal.ts
function gt(e) {
	return e === "boolean" ? {} : { stringValue: {
		default: void 0,
		keepOnSplit: !0,
		parseHTML: (e) => e.getAttribute("data-value"),
		renderHTML: (e) => e.stringValue === void 0 ? {} : { "data-value": e.stringValue }
	} };
}
function R(e, t, n, r) {
	return e.dom.setAttribute("data-style-type", t), r === "string" && e.dom.setAttribute("data-value", n), e.contentDOM && e.contentDOM.setAttribute("data-editable", ""), e;
}
function _t(e, t) {
	return {
		config: e,
		implementation: t
	};
}
function z(e, t) {
	return _t({
		type: e.name,
		propSchema: t
	}, {
		mark: e,
		render(t, n) {
			let r = n.pmSchema.marks[e.name].spec.toDOM;
			if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
			let i = n.pmSchema.mark(e.name, { stringValue: t }), a = ie.renderSpec(document, r(i, !0));
			if (typeof a != "object" || !("dom" in a)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property.");
			return a;
		},
		toExternalHTML(t, n) {
			let r = n.pmSchema.marks[e.name].spec.toDOM;
			if (r === void 0) throw Error("This block has no default HTML serialization as its corresponding TipTap node doesn't implement `renderHTML`.");
			let i = n.pmSchema.mark(e.name, { stringValue: t }), a = ie.renderSpec(document, r(i, !0));
			if (typeof a != "object" || !("dom" in a)) throw Error("Cannot use this block's default HTML serialization as its corresponding TipTap mark's `renderHTML` function does not return an object with the `dom` property.");
			return a;
		}
	});
}
function vt(e) {
	return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t.config]));
}
//#endregion
//#region src/schema/styles/createSpec.ts
function yt(e, t) {
	let n = [{
		tag: `[data-style-type="${e.type}"]`,
		contentElement: (e) => {
			let t = e;
			return t.matches("[data-editable]") ? t : t.querySelector("[data-editable]") || t;
		}
	}];
	return t && n.push({
		tag: "*",
		consuming: !1,
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t?.(e);
			return n === void 0 ? !1 : { stringValue: n };
		}
	}), n;
}
function bt(e, t) {
	let n = l.create({
		name: e.type,
		addAttributes() {
			return gt(e.propSchema);
		},
		parseHTML() {
			return yt(e, t.parse);
		},
		renderHTML({ mark: n }) {
			return R((t.toExternalHTML || t.render)(n.attrs.stringValue), e.type, n.attrs.stringValue, e.propSchema);
		},
		addMarkView() {
			return ({ mark: n }) => R(t.render(n.attrs.stringValue), e.type, n.attrs.stringValue, e.propSchema);
		}
	});
	return _t(e, {
		...t,
		mark: n,
		render: (n) => R(t.render(n), e.type, n, e.propSchema),
		toExternalHTML: (n) => R((t.toExternalHTML || t.render)(n), e.type, n, e.propSchema)
	});
}
//#endregion
//#region src/util/topo-sort.ts
function xt(e) {
	let t = Ct(e), { roots: n, nonRoots: r } = wt(t), i = [];
	for (; n.size;) {
		i.push(n);
		let r = /* @__PURE__ */ new Set();
		for (let i of n) {
			let n = e.get(i);
			if (n) for (let e of n) {
				let n = t.get(e);
				if (n === void 0) continue;
				let i = n - 1;
				t.set(e, i), i === 0 && r.add(e);
			}
		}
		n = r;
	}
	if (r = wt(t).nonRoots, r.size) throw Error(`Cycle(s) detected; toposort only works on acyclic graphs. Cyclic nodes: ${Array.from(r).join(", ")}`);
	return i;
}
function St(e) {
	return xt(Tt(e));
}
function Ct(e) {
	let t = /* @__PURE__ */ new Map();
	for (let [n, r] of e.entries()) {
		t.has(n) || t.set(n, 0);
		for (let e of r) {
			let n = t.get(e) ?? 0;
			t.set(e, n + 1);
		}
	}
	return t;
}
function wt(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
	for (let [r, i] of e.entries()) i === 0 ? t.add(r) : n.add(r);
	return {
		roots: t,
		nonRoots: n
	};
}
function Tt(e) {
	let t = /* @__PURE__ */ new Map();
	for (let [n, r] of e.entries()) {
		t.has(n) || t.set(n, /* @__PURE__ */ new Set());
		for (let e of r) t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
	}
	return t;
}
function Et() {
	return /* @__PURE__ */ new Map();
}
function Dt(e, t, n) {
	return e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n), e;
}
function Ot(e) {
	let t = Et();
	for (let n of e) Array.isArray(n.runsBefore) && n.runsBefore.length > 0 ? n.runsBefore.forEach((e) => {
		Dt(t, n.key, e);
	}) : Dt(t, "default", n.key);
	let n = St(t), r = n.findIndex((e) => e.has("default"));
	return (e) => 91 + (n.findIndex((t) => t.has(e)) + r) * 10;
}
//#endregion
//#region src/schema/schema.ts
function kt(e) {
	return e && Object.fromEntries(Object.entries(e).filter(([, e]) => e !== void 0));
}
var At = class {
	BlockNoteEditor = "only for types";
	Block = "only for types";
	PartialBlock = "only for types";
	inlineContentSpecs;
	styleSpecs;
	blockSpecs;
	blockSchema;
	inlineContentSchema;
	styleSchema;
	constructor(e) {
		this.opts = e;
		let { blockSpecs: t, inlineContentSpecs: n, styleSpecs: r, blockSchema: i, inlineContentSchema: a, styleSchema: o } = this.init();
		this.blockSpecs = t, this.styleSpecs = r, this.styleSchema = o, this.inlineContentSpecs = n, this.blockSchema = i, this.inlineContentSchema = a;
	}
	init() {
		let e = Ot(Object.entries({
			...this.opts.blockSpecs,
			...this.opts.inlineContentSpecs,
			...this.opts.styleSpecs
		}).map(([e, t]) => ({
			key: e,
			runsBefore: t.implementation?.runsBefore ?? []
		}))), t = Object.fromEntries(Object.entries(this.opts.blockSpecs).map(([t, n]) => [t, Ze(n.config, n.implementation, n.extensions, e(t))])), n = Object.fromEntries(Object.entries(this.opts.inlineContentSpecs).map(([t, n]) => typeof n.config == "object" ? [t, {
			...n,
			implementation: {
				...n.implementation,
				node: n.implementation?.node.extend({ priority: e(t) })
			}
		}] : [t, n])), r = Object.fromEntries(Object.entries(this.opts.styleSpecs).map(([t, n]) => [t, {
			...n,
			implementation: {
				...n.implementation,
				mark: n.implementation?.mark.extend({ priority: e(t) })
			}
		}]));
		return {
			blockSpecs: t,
			blockSchema: Object.fromEntries(Object.entries(t).map(([e, t]) => [e, t.config])),
			inlineContentSpecs: kt(n),
			styleSpecs: kt(r),
			inlineContentSchema: ht(n),
			styleSchema: vt(r)
		};
	}
	extend(e) {
		Object.assign(this.opts.blockSpecs, e.blockSpecs), Object.assign(this.opts.inlineContentSpecs, e.inlineContentSpecs), Object.assign(this.opts.styleSpecs, e.styleSpecs);
		let { blockSpecs: t, inlineContentSpecs: n, styleSpecs: r, blockSchema: i, inlineContentSchema: a, styleSchema: o } = this.init();
		return this.blockSpecs = t, this.styleSpecs = r, this.styleSchema = o, this.inlineContentSpecs = n, this.blockSchema = i, this.inlineContentSchema = a, this;
	}
};
//#endregion
//#region src/api/blockManipulation/tables/tables.ts
function B(e) {
	let { height: t, width: n } = jt(e), r = Array(t).fill(!1).map(() => Array(n).fill(null)), i = (e, i) => {
		for (let a = e; a < t; a++) for (let e = i; e < n; e++) if (!r[a][e]) return {
			row: a,
			col: e
		};
		throw Error("Unable to create occupancy grid for table, no more available cells");
	};
	for (let t = 0; t < e.content.rows.length; t++) for (let n = 0; n < e.content.rows[t].cells.length; n++) {
		let a = x(e.content.rows[t].cells[n]), o = Le(a), s = w(a), { row: c, col: l } = i(t, n);
		for (let e = c; e < c + o; e++) for (let i = l; i < l + s; i++) {
			if (r[e][i]) throw Error(`Unable to create occupancy grid for table, cell at ${e},${i} is already occupied`);
			r[e][i] = {
				row: t,
				col: n,
				rowspan: o,
				colspan: s,
				cell: a
			};
		}
	}
	return r;
}
function V(e) {
	let t = /* @__PURE__ */ new Set();
	return e.map((e) => ({ cells: e.map((e) => t.has(e.row + ":" + e.col) ? !1 : (t.add(e.row + ":" + e.col), e.cell)).filter((e) => e !== !1) }));
}
function H(e, t, n = B(t)) {
	for (let t = 0; t < n.length; t++) for (let r = 0; r < n[t].length; r++) {
		let i = n[t][r];
		if (i && i.row === e.row && i.col === e.col) return {
			row: t,
			col: r,
			cell: i.cell
		};
	}
	throw Error(`Unable to resolve relative table cell indices for table, cell at ${e.row},${e.col} is not occupied`);
}
function jt(e) {
	let t = e.content.rows.length, n = 0;
	return e.content.rows.forEach((e) => {
		let t = 0;
		e.cells.forEach((e) => {
			t += w(e);
		}), n = Math.max(n, t);
	}), {
		height: t,
		width: n
	};
}
function Mt(e, t, n = B(t)) {
	let r = n[e.row]?.[e.col];
	if (r) return {
		row: r.row,
		col: r.col,
		cell: r.cell
	};
}
function Nt(e, t) {
	let n = B(e);
	if (t < 0 || t >= n.length) return [];
	let r = 0;
	for (let e = 0; e < t; e++) {
		let e = n[r]?.[0];
		if (!e) return [];
		r += e.rowspan;
	}
	let i = Array(n[0].length).fill(!1).map((t, i) => Mt({
		row: r,
		col: i
	}, e, n)).filter((e) => e !== void 0);
	return i.filter((e, t) => i.findIndex((t) => t.row === e.row && t.col === e.col) === t);
}
function Pt(e, t) {
	let n = B(e);
	if (t < 0 || t >= n[0].length) return [];
	let r = 0;
	for (let e = 0; e < t; e++) {
		let e = n[0]?.[r];
		if (!e) return [];
		r += e.colspan;
	}
	let i = Array(n.length).fill(!1).map((t, i) => Mt({
		row: i,
		col: r
	}, e, n)).filter((e) => e !== void 0);
	return i.filter((e, t) => i.findIndex((t) => t.row === e.row && t.col === e.col) === t);
}
function Ft(e, t, n, r = B(e)) {
	let { col: i } = H({
		row: 0,
		col: t
	}, e, r), { col: a } = H({
		row: 0,
		col: n
	}, e, r);
	return r.forEach((e) => {
		let [t] = e.splice(i, 1);
		e.splice(a, 0, t);
	}), V(r);
}
function It(e, t, n, r = B(e)) {
	let { row: i } = H({
		row: t,
		col: 0
	}, e, r), { row: a } = H({
		row: n,
		col: 0
	}, e, r), [o] = r.splice(i, 1);
	return r.splice(a, 0, o), V(r);
}
function Lt(e) {
	return e ? S(e) ? Lt(e.content) : typeof e == "string" ? e.length === 0 : Array.isArray(e) ? e.every((e) => typeof e == "string" ? e.length === 0 : b(e) ? e.text.length === 0 : Ie(e) ? typeof e.content == "string" ? e.content.length === 0 : e.content.every((e) => e.text.length === 0) : !1) : !1 : !0;
}
function Rt(e, t, n = B(e)) {
	if (t === "columns") {
		let e = 0;
		for (let t = n[0].length - 1; t >= 0 && n.every((e) => Lt(e[t].cell) && e[t].colspan === 1); t--) e++;
		for (let t = n.length - 1; t >= 0; t--) {
			let r = Math.max(n[t].length - e, 1);
			n[t] = n[t].slice(0, r);
		}
		return V(n);
	}
	let r = 0;
	for (let e = n.length - 1; e >= 0 && n[e].every((e) => Lt(e.cell) && e.rowspan === 1); e--) r++;
	let i = Math.min(r, n.length - 1);
	return n.splice(n.length - i, i), V(n);
}
function zt(e, t, n, r = B(e)) {
	let { width: i, height: a } = jt(e);
	if (t === "columns") r.forEach((e, t) => {
		if (n >= 0) for (let r = 0; r < n; r++) e.push({
			row: t,
			col: Math.max(...e.map((e) => e.col)) + 1,
			rowspan: 1,
			colspan: 1,
			cell: x("")
		});
		else e.splice(i + n, -1 * n);
	});
	else if (n > 0) for (let e = 0; e < n; e++) {
		let t = Array(i).fill(null).map((t, n) => ({
			row: a + e,
			col: n,
			rowspan: 1,
			colspan: 1,
			cell: x("")
		}));
		r.push(t);
	}
	else n < 0 && r.splice(a + n, -1 * n);
	return V(r);
}
function Bt(e, t, n) {
	let r = Nt(e, n);
	if (!r.some((e) => Le(e.cell) > 1)) return !0;
	let i = n, a = n;
	return r.forEach((e) => {
		let t = Le(e.cell);
		i = Math.max(i, e.row + t - 1), a = Math.min(a, e.row);
	}), t < n ? n === i : n === a;
}
function Vt(e, t, n) {
	let r = Pt(e, n);
	if (!r.some((e) => w(e.cell) > 1)) return !0;
	let i = n, a = n;
	return r.forEach((e) => {
		let t = w(e.cell);
		i = Math.max(i, e.col + t - 1), a = Math.min(a, e.col);
	}), t < n ? n === i : n === a;
}
function Ht(e, t, n) {
	let r = H(e, n), i = H(t, n);
	return r.col === i.col;
}
//#endregion
//#region src/api/nodeConversions/blockToNode.ts
function Ut(e, t, n, r) {
	let i = [];
	for (let [r, a] of Object.entries(e.styles || {})) {
		let e = n[r];
		if (!e) throw Error(`style ${r} not found in styleSchema`);
		if (e.propSchema === "boolean") a && i.push(t.mark(r));
		else if (e.propSchema === "string") a && i.push(t.mark(r, { stringValue: a }));
		else throw new T(e.propSchema);
	}
	return !r || !t.nodes[r].spec.code ? e.text.split(/(\n)/g).filter((e) => e.length > 0).map((e) => e === "\n" ? t.nodes.hardBreak.createChecked() : t.text(e, i)) : e.text.length > 0 ? [t.text(e.text, i)] : [];
}
function Wt(e, t, n) {
	let r = t.marks.link.create({ href: e.href });
	return Gt(e.content, t, n).map((e) => {
		if (e.type.name === "text") return e.mark([...e.marks, r]);
		if (e.type.name === "hardBreak") return e;
		throw Error("unexpected node type");
	});
}
function Gt(e, t, n, r) {
	let i = [];
	if (typeof e == "string") return i.push(...Ut({
		type: "text",
		text: e,
		styles: {}
	}, t, n, r)), i;
	for (let a of e) i.push(...Ut(a, t, n, r));
	return i;
}
function U(e, t, n, r = F(t)) {
	let i = [];
	for (let a of e) typeof a == "string" ? i.push(...Gt(a, t, r, n)) : Ie(a) ? i.push(...Wt(a, t, r)) : b(a) ? i.push(...Gt([a], t, r, n)) : i.push(qt(a, t, r));
	return i;
}
function Kt(e, t, n = F(t)) {
	let r = [], i = Array(e.headerRows ?? 0).fill(!0), a = Array(e.headerCols ?? 0).fill(!0), o = e.columnWidths ?? [];
	for (let s = 0; s < e.rows.length; s++) {
		let c = e.rows[s], l = [], u = i[s];
		for (let r = 0; r < c.cells.length; r++) {
			let i = c.cells[r], d = a[r], f = null, p = H({
				row: s,
				col: r
			}, {
				type: "table",
				content: e
			}), m = o[p.col] ? [o[p.col]] : null;
			if (i) if (typeof i == "string") f = t.text(i);
			else if (S(i)) {
				i.content && (f = U(i.content, t, "tableParagraph", n));
				let e = w(i);
				e > 1 && (m = Array(e).fill(!1).map((e, t) => o[p.col + t] ?? void 0));
			} else f = U(i, t, "tableParagraph", n);
			let h = t.nodes[d || u ? "tableHeader" : "tableCell"].createChecked({
				...S(i) ? i.props : {},
				colwidth: m
			}, t.nodes.tableParagraph.createChecked(void 0, f));
			l.push(h);
		}
		let d = t.nodes.tableRow.createChecked({}, l);
		r.push(d);
	}
	return r;
}
function qt(e, t, n) {
	let r, i = e.type;
	if (i === void 0 && (i = "paragraph"), !t.nodes[i]) throw Error(`node type ${i} not found in schema`);
	if (!e.content) r = t.nodes[i].createChecked(e.props);
	else if (typeof e.content == "string") {
		let a = U([e.content], t, i, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else if (Array.isArray(e.content)) {
		let a = U(e.content, t, i, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else if (e.content.type === "tableContent") {
		let a = Kt(e.content, t, n);
		r = t.nodes[i].createChecked(e.props, a);
	} else throw new T(e.content.type);
	return r;
}
function W(e, t, n = F(t)) {
	let r = e.id;
	r === void 0 && (r = Pe.options.generateID());
	let i = [];
	if (e.children) for (let r of e.children) i.push(W(r, t, n));
	if (!e.type || t.nodes[e.type].isInGroup("blockContent")) {
		let a = qt(e, t, n), o = i.length > 0 ? t.nodes.blockGroup.createChecked({}, i) : void 0;
		return t.nodes.blockContainer.createChecked({
			id: r,
			...e.props
		}, o ? [a, o] : a);
	} else if (t.nodes[e.type].isInGroup("bnBlock")) return t.nodes[e.type].create({
		id: r,
		...e.props
	}, i);
	else throw Error(`block type ${e.type} doesn't match blockContent or bnBlock group`);
}
//#endregion
//#region src/api/nodeUtil.ts
function Jt(e, t) {
	let n, r;
	if (t.firstChild.descendants((t, i) => n ? !1 : !Yt(t) || t.attrs.id !== e ? !0 : (n = t, r = i + 1, !1)), !(n === void 0 || r === void 0)) return {
		node: n,
		posBeforeNode: r
	};
}
function Yt(e) {
	return e.type.isInGroup("bnBlock");
}
//#endregion
//#region src/api/blockManipulation/commands/updateBlock/updateBlock.ts
var Xt = (e, t) => ({ tr: n, dispatch: r }) => (r && G(n, e, t), !0);
function G(e, t, n, r, i) {
	let a = $e(e.doc.resolve(t)), o = null;
	a.blockNoteType === "table" && (o = en(e));
	let s = P(e);
	if (r !== void 0 && i !== void 0 && r > i) throw Error("Invalid replaceFromPos or replaceToPos");
	let c = s.nodes[a.blockNoteType], l = s.nodes[n.type || a.blockNoteType], u = l.isInGroup("bnBlock") ? l : s.nodes.blockContainer;
	if (a.isBlockContainer && l.isInGroup("blockContent")) {
		let t = r !== void 0 && r > a.blockContent.beforePos && r < a.blockContent.afterPos ? r - a.blockContent.beforePos - 1 : void 0, o = i !== void 0 && i > a.blockContent.beforePos && i < a.blockContent.afterPos ? i - a.blockContent.beforePos - 1 : void 0;
		Qt(n, e, a), Zt(n, e, c, l, a, t, o);
	} else if (!a.isBlockContainer && l.isInGroup("bnBlock")) Qt(n, e, a);
	else {
		let t = W({
			children: L(a.bnBlock.node, s).children,
			...n
		}, s);
		t.check(), e.replaceWith(a.bnBlock.beforePos, a.bnBlock.afterPos, t);
		return;
	}
	e.setNodeMarkup(a.bnBlock.beforePos, u, {
		...a.bnBlock.node.attrs,
		...n.props
	}), o && tn(e, a, o);
}
function Zt(e, t, n, a, o, s, c) {
	let l = P(t), u = "keep";
	if (e.content) if (typeof e.content == "string") u = U([e.content], l, a.name);
	else if (Array.isArray(e.content)) u = U(e.content, l, a.name);
	else if (e.content.type === "tableContent") u = Kt(e.content, l);
	else throw new T(e.content.type);
	else n.spec.content === "" || a.spec.content !== n.spec.content && (u = []);
	if (u === "keep") t.setNodeMarkup(o.blockContent.beforePos, a, {
		...o.blockContent.node.attrs,
		...e.props
	});
	else if (s !== void 0 || c !== void 0) {
		t.setNodeMarkup(o.blockContent.beforePos, a, {
			...o.blockContent.node.attrs,
			...e.props
		});
		let n = o.blockContent.beforePos + 1 + (s ?? 0), l = o.blockContent.beforePos + 1 + (c ?? o.blockContent.node.content.size), d = t.doc.resolve(o.blockContent.beforePos).depth, f = t.doc.resolve(n).depth, p = t.doc.resolve(l).depth;
		t.replace(n, l, new i(r.from(u), f - d - 1, p - d - 1));
	} else t.replaceWith(o.blockContent.beforePos, o.blockContent.afterPos, a.createChecked({
		...o.blockContent.node.attrs,
		...e.props
	}, u));
}
function Qt(e, t, n) {
	let a = P(t);
	if (e.children !== void 0 && e.children.length > 0) {
		let s = e.children.map((e) => {
			let t = W(e, a);
			return t.check(), t;
		});
		if (n.childContainer) t.step(new o(n.childContainer.beforePos + 1, n.childContainer.afterPos - 1, new i(r.from(s), 0, 0)));
		else {
			if (!n.isBlockContainer) throw Error("impossible");
			t.insert(n.blockContent.afterPos, a.nodes.blockGroup.createChecked({}, s));
		}
	}
}
function $t(e, t, n, r, i) {
	let a = typeof t == "string" ? t : t.id, o = Jt(a, e.doc);
	if (!o) throw Error(`Block with ID ${a} not found`);
	return G(e, o.posBeforeNode, n, r, i), L(e.doc.resolve(o.posBeforeNode + 1).node(), P(e));
}
function en(e) {
	let t = "selection" in e ? e.selection : null;
	if (!(t instanceof te)) return null;
	let n = e.doc.resolve(t.head), r = -1, i = -1;
	for (let e = n.depth; e >= 0; e--) {
		let t = n.node(e).type.name;
		if (r < 0 && (t === "tableCell" || t === "tableHeader") && (r = e), t === "table") {
			i = e;
			break;
		}
	}
	if (r < 0 || i < 0) return null;
	let a = n.before(r), o = n.before(i), s = e.doc.nodeAt(o);
	if (!s || s.type.name !== "table") return null;
	let c = se.get(s), l = a - (o + 1), u = c.map.indexOf(l);
	if (u < 0) return null;
	let d = Math.floor(u / c.width), f = u % c.width, p = a + 1 + 1;
	return {
		row: d,
		col: f,
		offset: Math.max(0, t.head - p)
	};
}
function tn(e, t, n) {
	if (t.blockNoteType !== "table") return !1;
	let r = -1;
	if (t.isBlockContainer) r = e.mapping.map(t.blockContent.beforePos);
	else {
		let n = e.mapping.map(t.bnBlock.beforePos), i = n + (e.doc.nodeAt(n)?.nodeSize || 0);
		e.doc.nodesBetween(n, i, (e, t) => e.type.name === "table" ? (r = t, !1) : !0);
	}
	let i = r >= 0 ? e.doc.nodeAt(r) : null;
	if (!i || i.type.name !== "table") return !1;
	let a = se.get(i), o = Math.max(0, Math.min(n.row, a.height - 1)), s = Math.max(0, Math.min(n.col, a.width - 1)), c = o * a.width + s, l = a.map[c];
	if (l == null) return !1;
	let u = r + 1 + l + 1, d = e.doc.nodeAt(u), f = u + 1, p = d ? d.content.size : 0, m = f + Math.max(0, Math.min(n.offset, p));
	return "selection" in e && e.setSelection(te.create(e.doc, m)), !0;
}
//#endregion
//#region src/editor/defaultColors.ts
var K = {
	gray: {
		text: "#9b9a97",
		background: "#ebeced"
	},
	brown: {
		text: "#64473a",
		background: "#e9e5e3"
	},
	red: {
		text: "#e03e3e",
		background: "#fbe4e4"
	},
	orange: {
		text: "#d9730d",
		background: "#f6e9d9"
	},
	yellow: {
		text: "#dfab01",
		background: "#fbf3db"
	},
	green: {
		text: "#4d6461",
		background: "#ddedea"
	},
	blue: {
		text: "#0b6e99",
		background: "#ddebf1"
	},
	purple: {
		text: "#6940a5",
		background: "#eae4f2"
	},
	pink: {
		text: "#ad1a72",
		background: "#f4dfeb"
	}
}, nn = {
	gray: {
		text: "#bebdb8",
		background: "#9b9a97"
	},
	brown: {
		text: "#8e6552",
		background: "#64473a"
	},
	red: {
		text: "#ec4040",
		background: "#be3434"
	},
	orange: {
		text: "#e3790d",
		background: "#b7600a"
	},
	yellow: {
		text: "#dfab01",
		background: "#b58b00"
	},
	green: {
		text: "#6b8b87",
		background: "#4d6461"
	},
	blue: {
		text: "#0e87bc",
		background: "#0b6e99"
	},
	purple: {
		text: "#8552d7",
		background: "#6940a5"
	},
	pink: {
		text: "#da208f",
		background: "#ad1a72"
	}
}, q = {
	backgroundColor: { default: "default" },
	textColor: { default: "default" },
	textAlignment: {
		default: "left",
		values: [
			"left",
			"center",
			"right",
			"justify"
		]
	}
}, J = (e) => {
	let t = {};
	return e.hasAttribute("data-background-color") ? t.backgroundColor = e.getAttribute("data-background-color") : e.style.backgroundColor && (t.backgroundColor = e.style.backgroundColor), e.hasAttribute("data-text-color") ? t.textColor = e.getAttribute("data-text-color") : e.style.color && (t.textColor = e.style.color), t.textAlignment = q.textAlignment.values.includes(e.style.textAlign) ? e.style.textAlign : void 0, t;
}, Y = (e, t) => {
	e.backgroundColor && e.backgroundColor !== q.backgroundColor.default && (t.style.backgroundColor = e.backgroundColor in K ? K[e.backgroundColor].background : e.backgroundColor), e.textColor && e.textColor !== q.textColor.default && (t.style.color = e.textColor in K ? K[e.textColor].text : e.textColor), e.textAlignment && e.textAlignment !== q.textAlignment.default && (t.style.textAlign = e.textAlignment);
}, rn = (e = "backgroundColor") => ({
	default: q.backgroundColor.default,
	parseHTML: (e) => e.hasAttribute("data-background-color") ? e.getAttribute("data-background-color") : e.style.backgroundColor ? e.style.backgroundColor : q.backgroundColor.default,
	renderHTML: (t) => t[e] === q.backgroundColor.default ? {} : { "data-background-color": t[e] }
}), an = (e = "textColor") => ({
	default: q.textColor.default,
	parseHTML: (e) => e.hasAttribute("data-text-color") ? e.getAttribute("data-text-color") : e.style.color ? e.style.color : q.textColor.default,
	renderHTML: (t) => t[e] === q.textColor.default ? {} : { "data-text-color": t[e] }
}), on = (e = "textAlignment") => ({
	default: q.textAlignment.default,
	parseHTML: (e) => e.hasAttribute("data-text-alignment") ? e.getAttribute("data-text-alignment") : e.style.textAlign ? e.style.textAlign : q.textAlignment.default,
	renderHTML: (t) => t[e] === q.textAlignment.default ? {} : { "data-text-alignment": t[e] }
}), sn = (e, t) => {
	let n = e.querySelector(t);
	if (n) return {
		targetElement: n,
		caption: e.querySelector("figcaption")?.textContent ?? void 0
	};
}, X = t(({ editor: t }) => {
	let n = e(void 0);
	function r() {
		n.setState(void 0);
	}
	return {
		key: "filePanel",
		store: n,
		mount({ signal: e }) {
			let n = t.onChange(r, !1), i = t.onSelectionChange(r, !1);
			e.addEventListener("abort", () => {
				n(), i();
			});
		},
		closeMenu: r,
		showMenu(e) {
			n.setState(e);
		}
	};
}), cn = (e, t, n) => {
	let r = document.createElement("div");
	r.className = "bn-add-file-button";
	let i = document.createElement("div");
	i.className = "bn-add-file-button-icon", n ? i.appendChild(n) : i.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z\"></path></svg>", r.appendChild(i);
	let a = document.createElement("p");
	a.className = "bn-add-file-button-text", a.innerHTML = e.type in t.dictionary.file_blocks.add_button_text ? t.dictionary.file_blocks.add_button_text[e.type] : t.dictionary.file_blocks.add_button_text.file, r.appendChild(a);
	let o = (e) => {
		e.preventDefault(), e.stopPropagation();
	}, s = () => {
		t.isEditable && t.getExtension(X)?.showMenu(e.id);
	};
	return r.addEventListener("mousedown", o, !0), r.addEventListener("click", s, !0), {
		dom: r,
		destroy: () => {
			r.removeEventListener("mousedown", o, !0), r.removeEventListener("click", s, !0);
		}
	};
}, ln = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z\"></path></svg>", un = (e) => {
	let t = document.createElement("div");
	t.className = "bn-file-name-with-icon";
	let n = document.createElement("div");
	n.className = "bn-file-icon", n.innerHTML = ln, t.appendChild(n);
	let r = document.createElement("p");
	return r.className = "bn-file-name", r.textContent = e.props.name, t.appendChild(r), { dom: t };
}, dn = (e, t, n, r) => {
	let i = e.props.url !== "" && !!e.props.caption, a = document.createElement(i ? "figure" : "div");
	if (a.className = "bn-file-block-content-wrapper", e.props.url === "") {
		let n = cn(e, t, r);
		a.appendChild(n.dom);
		let i = t.onUploadStart((t) => {
			if (t === e.id) {
				a.removeChild(n.dom);
				let e = document.createElement("div");
				e.className = "bn-file-loading-preview", e.textContent = "Loading...", a.appendChild(e);
			}
		});
		return {
			dom: a,
			destroy: () => {
				i(), n.destroy();
			}
		};
	}
	let o = { dom: a };
	if (e.props.showPreview === !1 || !n) {
		let t = un(e);
		a.appendChild(t.dom), o.destroy = () => {
			t.destroy?.();
		};
	} else a.appendChild(n.dom);
	if (e.props.caption) {
		let t = document.createElement("figcaption");
		t.className = "bn-file-caption", t.textContent = e.props.caption, a.appendChild(t);
	}
	return o;
}, fn = (e, t) => {
	let n = document.createElement("figure"), r = document.createElement("figcaption");
	return r.textContent = t, n.appendChild(e), n.appendChild(r), { dom: n };
}, pn = (e, t) => {
	let n = document.createElement("div"), r = document.createElement("p");
	return r.textContent = t, n.appendChild(e), n.appendChild(r), { dom: n };
}, mn = (e) => ({ url: e.src || void 0 }), hn = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z\"></path></svg>", gn = A((e) => ({
	type: "audio",
	propSchema: {
		backgroundColor: q.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 }
	},
	content: "none"
})), _n = (e = {}) => (e) => {
	if (e.tagName === "AUDIO") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = J(e);
		return {
			...mn(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = sn(e, "audio");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = J(e);
		return {
			...mn(n),
			backgroundColor: i,
			caption: r
		};
	}
}, vn = (e = {}) => (t, n) => {
	let r = document.createElement("div");
	r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z\"></path></svg>";
	let i = document.createElement("audio");
	return i.className = "bn-audio", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
		i.src = e;
	}) : i.src = t.props.url, i.controls = !0, i.contentEditable = "false", i.draggable = !1, dn(t, n, { dom: i }, r.firstElementChild);
}, yn = (e = {}) => (e, t) => {
	if (!e.props.url) return { dom: document.createElement("audio") };
	let n;
	return e.props.showPreview ? (n = document.createElement("audio"), n.src = e.props.url) : (n = document.createElement("a"), n.href = e.props.url, n.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? fn(n, e.props.caption) : pn(n, e.props.caption) : { dom: n };
}, bn = j(gn, (e) => ({
	meta: { fileBlockAccept: ["audio/*"] },
	parse: _n(e),
	render: vn(e),
	toExternalHTML: yn(e),
	runsBefore: ["file"]
})), xn = Symbol.for("blocknote.shikiParser"), Sn = Symbol.for("blocknote.shikiHighlighterPromise");
function Cn(e) {
	let t = globalThis, n, r, i = !1;
	return ge({
		parser: (a) => {
			if (!e.createHighlighter) return process.env.NODE_ENV === "development" && !i && (console.log("For syntax highlighting of code blocks, you must provide a `createCodeBlockSpec({ createHighlighter: () => ... })` function"), i = !0), [];
			if (!n) return t[Sn] = t[Sn] || e.createHighlighter(), t[Sn].then((e) => {
				n = e;
			});
			let o = En(e, a.language);
			return !o || o === "text" || o === "none" || o === "plaintext" || o === "txt" ? [] : n.getLoadedLanguages().includes(o) ? (r || (r = t[xn] || _e(n), t[xn] = r), r(a)) : n.loadLanguage(o);
		},
		languageExtractor: (e) => e.attrs.language,
		nodeTypes: ["codeBlock"]
	});
}
//#endregion
//#region src/blocks/Code/block.ts
var wn = A(({ defaultLanguage: e = "text" }) => ({
	type: "codeBlock",
	propSchema: { language: { default: e } },
	content: "inline"
})), Tn = j(wn, (e) => ({
	meta: {
		code: !0,
		defining: !0,
		isolating: !1
	},
	parse: (e) => {
		if (e.tagName !== "PRE" || e.childElementCount !== 1 || e.firstElementChild?.tagName !== "CODE") return;
		let t = e.firstElementChild;
		return { language: t.getAttribute("data-language") || t.className.split(" ").find((e) => e.includes("language-"))?.replace("language-", "") };
	},
	parseContent: ({ el: e, schema: t }) => {
		let n = re.fromSchema(t), r = e.firstElementChild;
		return n.parse(r, {
			preserveWhitespace: "full",
			topNode: t.nodes.codeBlock.create()
		}).content;
	},
	render(t, n) {
		let r = document.createDocumentFragment(), i = document.createElement("pre"), a = document.createElement("code");
		i.appendChild(a);
		let o;
		if (e.supportedLanguages) {
			let i = document.createElement("select");
			if (Object.entries(e.supportedLanguages ?? {}).forEach(([e, { name: t }]) => {
				let n = document.createElement("option");
				n.value = e, n.text = t, i.appendChild(n);
			}), i.value = t.props.language || e.defaultLanguage || "text", n.isEditable) {
				let e = (e) => {
					let r = e.target.value;
					n.updateBlock(t.id, { props: { language: r } });
				};
				i.addEventListener("change", e), o = () => i.removeEventListener("change", e);
			} else i.disabled = !0;
			let a = document.createElement("div");
			a.contentEditable = "false", a.appendChild(i), r.appendChild(a);
		}
		return r.appendChild(i), {
			dom: r,
			contentDOM: a,
			destroy: () => {
				o?.();
			}
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("pre"), n = document.createElement("code");
		return n.className = `language-${e.props.language}`, n.dataset.language = e.props.language, t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}), (e) => [t({
	key: "code-block-highlighter",
	prosemirrorPlugins: [Cn(e)]
}), t({
	key: "code-block-keyboard-shortcuts",
	keyboardShortcuts: {
		Delete: ({ editor: e }) => e.transact((t) => {
			let { block: n } = e.getTextCursorPosition();
			if (n.type !== "codeBlock") return !1;
			let { $from: r } = t.selection;
			return r.parent.textContent ? !1 : (e.removeBlocks([n]), !0);
		}),
		Tab: ({ editor: t }) => e.indentLineWithTab === !1 ? !1 : t.transact((e) => {
			let { block: n } = t.getTextCursorPosition();
			return n.type === "codeBlock" ? (e.insertText("  "), !0) : !1;
		}),
		Enter: ({ editor: e }) => e.transact((t) => {
			let { block: n, nextBlock: r } = e.getTextCursorPosition();
			if (n.type !== "codeBlock") return !1;
			let { $from: i } = t.selection, a = i.parentOffset === i.parent.nodeSize - 2, o = i.parent.textContent.endsWith("\n\n");
			if (a && o) {
				if (t.delete(i.pos - 2, i.pos), r) return e.setTextCursorPosition(r, "start"), !0;
				let [a] = e.insertBlocks([{ type: "paragraph" }], n, "after");
				return e.setTextCursorPosition(a, "start"), !0;
			}
			return t.insertText("\n"), !0;
		}),
		"Shift-Enter": ({ editor: e }) => e.transact(() => {
			let { block: t } = e.getTextCursorPosition();
			if (t.type !== "codeBlock") return !1;
			let [n] = e.insertBlocks([{ type: "paragraph" }], t, "after");
			return e.setTextCursorPosition(n, "start"), !0;
		})
	},
	inputRules: [{
		find: /^```(.*?)\s$/,
		replace: ({ match: t }) => {
			let n = t[1].trim();
			return {
				type: "codeBlock",
				props: { language: { language: En(e, n) ?? n }.language },
				content: []
			};
		}
	}]
})]);
function En(e, t) {
	return Object.entries(e.supportedLanguages ?? {}).find(([e, { aliases: n }]) => n?.includes(t) || e === t)?.[0];
}
//#endregion
//#region src/blocks/Divider/block.ts
var Dn = A(() => ({
	type: "divider",
	propSchema: {},
	content: "none"
})), On = j(Dn, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "HR") return {};
	},
	render() {
		return { dom: document.createElement("hr") };
	}
}, [t({
	key: "divider-block-shortcuts",
	inputRules: [{
		find: RegExp("^---$"),
		replace() {
			return {
				type: "divider",
				props: {},
				content: []
			};
		}
	}]
})]), kn = (e) => ({ url: e.src || void 0 }), An = A(() => ({
	type: "file",
	propSchema: {
		backgroundColor: q.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" }
	},
	content: "none"
})), jn = () => (e) => {
	if (e.tagName === "EMBED") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = J(e);
		return {
			...kn(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = sn(e, "embed");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = J(e);
		return {
			...kn(n),
			backgroundColor: i,
			caption: r
		};
	}
}, Mn = j(An, {
	meta: { fileBlockAccept: ["*/*"] },
	parse: jn(),
	render(e, t) {
		return dn(e, t);
	},
	toExternalHTML(e) {
		if (!e.props.url) return { dom: document.createElement("embed") };
		let t = document.createElement("a");
		return t.href = e.props.url, t.textContent = e.props.name || e.props.url, e.props.caption ? pn(t, e.props.caption) : { dom: t };
	}
});
//#endregion
//#region src/blocks/getDetailsContent.ts
function Nn(e, t, i) {
	let a = n.fromSchema(t), o = e.querySelector(":scope > summary"), s;
	if (o) {
		let e = o.cloneNode(!0);
		Ue(e), s = a.parse(e, {
			topNode: t.nodes.paragraph.create(),
			preserveWhitespace: !0
		}).content;
	} else s = r.empty;
	let c = document.createElement("div");
	c.setAttribute("data-node-type", "blockGroup");
	let l = !1;
	for (let t of Array.from(e.childNodes)) t.tagName !== "SUMMARY" && (t.nodeType === 3 && !t.textContent?.trim() || (l = !0, c.appendChild(t.cloneNode(!0))));
	let u = t.nodes[i].create({}, s);
	if (!l) return u.content;
	let d = a.parse(c, { topNode: t.nodes.blockGroup.create() });
	return d.content.size > 0 ? u.content.addToEnd(d) : u.content;
}
//#endregion
//#region src/blocks/ToggleWrapper/createToggleWrapper.ts
var Pn = {
	set: (e, t) => window.localStorage.setItem(`toggle-${e.id}`, t ? "true" : "false"),
	get: (e) => window.localStorage.getItem(`toggle-${e.id}`) === "true"
}, Fn = (e, t, n, r = Pn) => {
	if ("isToggleable" in e.props && !e.props.isToggleable) return { dom: n };
	let i = document.createElement("div"), a = document.createElement("div");
	a.className = "bn-toggle-wrapper";
	let o = document.createElement("button");
	o.className = "bn-toggle-button", o.type = "button", o.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"CURRENTCOLOR\"><path d=\"M320-200v-560l440 280-440 280Z\"/></svg>";
	let s = (e) => e.preventDefault();
	o.addEventListener("mousedown", s);
	let c = () => {
		a.getAttribute("data-show-children") === "true" ? (a.setAttribute("data-show-children", "false"), r.set(t.getBlock(e), !1), i.contains(l) && i.removeChild(l)) : (a.setAttribute("data-show-children", "true"), r.set(t.getBlock(e), !0), t.isEditable && t.getBlock(e)?.children.length === 0 && !i.contains(l) && i.appendChild(l));
	};
	o.addEventListener("click", c), a.appendChild(o), a.appendChild(n);
	let l = document.createElement("button");
	l.className = "bn-toggle-add-block-button", l.type = "button", l.textContent = t.dictionary.toggle_blocks.add_block_button;
	let u = (e) => e.preventDefault();
	l.addEventListener("mousedown", u);
	let d = () => {
		t.transact(() => {
			let n = t.updateBlock(e, { children: [{}] });
			t.setTextCursorPosition(n.children[0].id, "end"), t.focus();
		});
	};
	l.addEventListener("click", d), i.appendChild(a);
	let f = e.children.length, p = t.onChange(() => {
		let n = t.getBlock(e)?.children.length ?? 0;
		n > f ? (a.getAttribute("data-show-children") === "false" && (a.setAttribute("data-show-children", "true"), r.set(t.getBlock(e), !0)), i.contains(l) && i.removeChild(l)) : n === 0 && n < f && (a.getAttribute("data-show-children") === "true" && (a.setAttribute("data-show-children", "false"), r.set(t.getBlock(e), !1)), i.contains(l) && i.removeChild(l)), f = n;
	});
	return r.get(e) ? (a.setAttribute("data-show-children", "true"), t.isEditable && e.children.length === 0 && i.appendChild(l)) : a.setAttribute("data-show-children", "false"), {
		dom: i,
		ignoreMutation: (e) => e instanceof MutationRecord && (e.type === "attributes" && e.target === a && e.attributeName === "data-show-children" || e.type === "childList" && (e.addedNodes[0] === l || e.removedNodes[0] === l)),
		destroy: () => {
			o.removeEventListener("mousedown", s), o.removeEventListener("click", c), l.removeEventListener("mousedown", u), l.removeEventListener("click", d), p?.();
		}
	};
}, In = [
	1,
	2,
	3,
	4,
	5,
	6
], Ln = (e) => ({ editor: t }) => {
	let n = t.getTextCursorPosition();
	return t.schema.blockSchema[n.block.type].content === "inline" ? (t.updateBlock(n.block, {
		type: "heading",
		props: { level: e }
	}), !0) : !1;
}, Rn = A(({ defaultLevel: e = 1, levels: t = In, allowToggleHeadings: n = !0 } = {}) => ({
	type: "heading",
	propSchema: {
		...q,
		level: {
			default: e,
			values: t
		},
		...n ? { isToggleable: {
			default: !1,
			optional: !0
		} } : {}
	},
	content: "inline"
})), zn = j(Rn, ({ allowToggleHeadings: e = !0 } = {}) => ({
	meta: { isolating: !1 },
	parse(t) {
		if (e && t.tagName === "DETAILS") {
			let e = t.querySelector(":scope > summary");
			if (!e) return;
			let n = e.querySelector("h1, h2, h3, h4, h5, h6");
			return n ? {
				...J(n),
				level: parseInt(n.tagName[1]),
				isToggleable: !0
			} : void 0;
		}
		let n;
		switch (t.tagName) {
			case "H1":
				n = 1;
				break;
			case "H2":
				n = 2;
				break;
			case "H3":
				n = 3;
				break;
			case "H4":
				n = 4;
				break;
			case "H5":
				n = 5;
				break;
			case "H6":
				n = 6;
				break;
			default: return;
		}
		return {
			...J(t),
			level: n
		};
	},
	...e ? { parseContent: ({ el: e, schema: t }) => {
		if (e.tagName === "DETAILS") return Nn(e, t, "heading");
	} } : {},
	runsBefore: ["toggleListItem"],
	render(t, n) {
		let r = document.createElement(`h${t.props.level}`);
		return e ? {
			...Fn(t, n, r),
			contentDOM: r
		} : {
			dom: r,
			contentDOM: r
		};
	},
	toExternalHTML(t) {
		let n = document.createElement(`h${t.props.level}`);
		if (Y(t.props, n), e && t.props.isToggleable) {
			let e = document.createElement("details");
			e.setAttribute("open", "");
			let t = document.createElement("summary");
			return t.appendChild(n), e.appendChild(t), {
				dom: e,
				contentDOM: n,
				childrenDOM: e
			};
		}
		return {
			dom: n,
			contentDOM: n
		};
	}
}), ({ levels: e = In } = {}) => [t({
	key: "heading-shortcuts",
	keyboardShortcuts: Object.fromEntries(e.map((e) => [`Mod-Alt-${e}`, Ln(e)]) ?? []),
	inputRules: e.map((e) => ({
		find: RegExp(`^(#{${e}})\\s$`),
		replace({ match: e }) {
			return {
				type: "heading",
				props: { level: e[1].length }
			};
		}
	}))
})]), Bn = (e, t, n, r, i) => {
	let { dom: a, destroy: o } = dn(e, t, n, i), s = a;
	s.style.position = "relative", e.props.url && e.props.showPreview && (e.props.previewWidth ? s.style.width = `${e.props.previewWidth}px` : s.style.width = "fit-content");
	let c = document.createElement("div");
	c.className = "bn-resize-handle", c.style.left = "4px", c.style.display = "none", r.appendChild(c);
	let l = document.createElement("div");
	l.className = "bn-resize-handle", l.style.right = "4px", l.style.display = "none", r.appendChild(l);
	let u = document.createElement("div");
	u.style.position = "absolute", u.style.height = "100%", u.style.width = "100%";
	let d, f = e.props.previewWidth, p = (n) => {
		if (!d) {
			t.isEditable || (c.style.display = "none", l.style.display = "none");
			return;
		}
		let r, i = "touches" in n ? n.touches[0].clientX : n.clientX;
		r = e.props.textAlignment === "center" ? d.handleUsed === "left" ? d.initialWidth + (d.initialClientX - i) * 2 : d.initialWidth + (i - d.initialClientX) * 2 : d.handleUsed === "left" ? d.initialWidth + d.initialClientX - i : d.initialWidth + i - d.initialClientX, f = Math.min(Math.max(r, 64), t.domElement?.firstElementChild?.clientWidth || Number.MAX_VALUE), s.style.width = `${f}px`;
	}, m = (n) => {
		(!n.target || !s.contains(n.target) || !t.isEditable) && (c.style.display = "none", l.style.display = "none"), d && (d = void 0, s.contains(u) && s.removeChild(u), t.updateBlock(e, { props: { previewWidth: f } }));
	}, h = () => {
		t.isEditable && (c.style.display = "", l.style.display = "");
	}, g = (e) => {
		e.relatedTarget === c || e.relatedTarget === l || d || t.isEditable && (c.style.display = "none", l.style.display = "none");
	}, _ = (e) => {
		e.preventDefault(), s.contains(u) || s.appendChild(u);
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		d = {
			handleUsed: "left",
			initialWidth: s.clientWidth,
			initialClientX: t
		};
	}, v = (e) => {
		e.preventDefault(), s.contains(u) || s.appendChild(u);
		let t = "touches" in e ? e.touches[0].clientX : e.clientX;
		d = {
			handleUsed: "right",
			initialWidth: s.clientWidth,
			initialClientX: t
		};
	};
	return window.addEventListener("mousemove", p), window.addEventListener("touchmove", p), window.addEventListener("mouseup", m), window.addEventListener("touchend", m), s.addEventListener("mouseenter", h), s.addEventListener("mouseleave", g), c.addEventListener("mousedown", _), c.addEventListener("touchstart", _), l.addEventListener("mousedown", v), l.addEventListener("touchstart", v), {
		dom: s,
		destroy: () => {
			o?.(), window.removeEventListener("mousemove", p), window.removeEventListener("touchmove", p), window.removeEventListener("mouseup", m), window.removeEventListener("touchend", m), s.removeEventListener("mouseenter", h), s.removeEventListener("mouseleave", g), c.removeEventListener("mousedown", _), c.removeEventListener("touchstart", _), l.removeEventListener("mousedown", v), l.removeEventListener("touchstart", v);
		}
	};
}, Vn = (e) => ({
	url: e.src || void 0,
	previewWidth: e.width || void 0,
	name: e.alt || void 0
}), Hn = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z\"></path></svg>", Un = A((e = {}) => ({
	type: "image",
	propSchema: {
		textAlignment: q.textAlignment,
		backgroundColor: q.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 },
		previewWidth: {
			default: void 0,
			type: "number"
		}
	},
	content: "none"
})), Wn = (e = {}) => (e) => {
	if (e.tagName === "IMG") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = J(e);
		return {
			...Vn(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = sn(e, "img");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = J(e);
		return {
			...Vn(n),
			backgroundColor: i,
			caption: r
		};
	}
}, Gn = (e = {}) => (t, n) => {
	let r = document.createElement("div");
	r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z\"></path></svg>";
	let i = document.createElement("div");
	i.className = "bn-visual-media-wrapper";
	let a = document.createElement("img");
	return a.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
		a.src = e;
	}) : a.src = t.props.url, a.alt = t.props.name || "", a.contentEditable = "false", a.draggable = !1, i.appendChild(a), Bn(t, n, { dom: i }, i, r.firstElementChild);
}, Kn = (e = {}) => (e, t) => {
	if (!e.props.url) return { dom: document.createElement("img") };
	let n;
	return e.props.showPreview ? (n = document.createElement("img"), n.src = e.props.url, n.alt = e.props.name || "", e.props.previewWidth && (n.width = e.props.previewWidth)) : (n = document.createElement("a"), n.href = e.props.url, n.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? fn(n, e.props.caption) : pn(n, e.props.caption) : { dom: n };
}, qn = j(Un, (e) => ({
	meta: { fileBlockAccept: ["image/*"] },
	parse: Wn(e),
	render: Gn(e),
	toExternalHTML: Kn(e),
	runsBefore: ["file"]
})), Jn = (e, t, n) => ({ state: r, dispatch: i }) => i ? Yn(r.tr, e, t, n) : !0, Yn = (e, t, n, r) => {
	let i = N(M(e.doc, t));
	if (!i.isBlockContainer) return !1;
	let a = P(e), o = [{
		type: i.bnBlock.node.type,
		attrs: r ? {
			...i.bnBlock.node.attrs,
			id: void 0
		} : {}
	}, {
		type: n ? i.blockContent.node.type : a.nodes.paragraph,
		attrs: r ? { ...i.blockContent.node.attrs } : {}
	}];
	return e.split(t, 2, o), !0;
}, Xn = (e, t) => {
	let { blockInfo: n, selectionEmpty: r } = e.transact((e) => ({
		blockInfo: tt(e),
		selectionEmpty: e.selection.anchor === e.selection.head
	}));
	if (!n.isBlockContainer) return !1;
	let { bnBlock: i, blockContent: a } = n;
	return a.node.type.name !== t || !r ? !1 : a.node.childCount === 0 ? (e.transact((e) => {
		G(e, i.beforePos, {
			type: "paragraph",
			props: {}
		});
	}), !0) : a.node.childCount > 0 ? e.transact((e) => (e.deleteSelection(), Yn(e, e.selection.from, !0))) : !1;
};
//#endregion
//#region src/blocks/ListItem/getListItemContent.ts
function Zn(e, t, i) {
	let a = n.fromSchema(t), o = e, s = document.createElement("div");
	s.setAttribute("data-node-type", "blockGroup");
	for (let e of Array.from(o.childNodes)) s.appendChild(e.cloneNode(!0));
	let c = a.parse(s, { topNode: t.nodes.blockGroup.create() });
	c.firstChild?.firstChild?.type.name === "checkListItem" && (c = c.copy(c.content.cut(c.firstChild.firstChild.nodeSize + 2)));
	let l = c.firstChild?.firstChild;
	if (!l?.isTextblock) return r.from(c);
	let u = t.nodes[i].create({}, l.content), d = c.content.cut(l.nodeSize + 2);
	if (d.size > 0) {
		let e = c.copy(d);
		return u.content.addToEnd(e);
	}
	return u.content;
}
//#endregion
//#region src/blocks/ListItem/BulletListItem/block.ts
var Qn = A(() => ({
	type: "bulletListItem",
	propSchema: { ...q },
	content: "inline"
})), $n = j(Qn, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t !== null && (t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL")) return J(e);
	},
	parseContent: ({ el: e, schema: t }) => Zn(e, t, "bulletListItem"),
	render() {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("p");
		return Y(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}, [t({
	key: "bullet-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Xn(e, "bulletListItem"),
		"Mod-Shift-8": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "bulletListItem",
				props: {}
			}), !0) : !1;
		}
	},
	inputRules: [{
		find: /^\s?[-+*]\s$/,
		replace({ editor: e }) {
			if (et(e.prosemirrorState).blockNoteType !== "heading") return {
				type: "bulletListItem",
				props: {}
			};
		}
	}]
})]), er = A(() => ({
	type: "checkListItem",
	propSchema: {
		...q,
		checked: {
			default: !1,
			type: "boolean"
		}
	},
	content: "inline"
})), tr = j(er, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "input") return e.closest("[data-content-type]") || e.closest("li") ? void 0 : e.type === "checkbox" ? { checked: e.checked } : void 0;
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t !== null && (t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL")) {
			let t = e.querySelector("input[type=checkbox]") || null;
			return t === null ? void 0 : {
				...J(e),
				checked: t.checked
			};
		}
	},
	parseContent: ({ el: e, schema: t }) => Zn(e, t, "checkListItem"),
	render(e, t) {
		let n = document.createDocumentFragment(), r = document.createElement("input");
		r.type = "checkbox", r.checked = e.props.checked, e.props.checked && r.setAttribute("checked", ""), r.disabled = !t.isEditable, r.addEventListener("change", () => {
			t.isEditable && t.updateBlock(e, { props: { checked: !e.props.checked } });
		});
		let i = document.createElement("p"), a = document.createElement("div");
		return a.contentEditable = "false", a.appendChild(r), n.appendChild(a), n.appendChild(i), {
			dom: n,
			contentDOM: i
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("input");
		n.type = "checkbox", n.checked = e.props.checked, e.props.checked && n.setAttribute("checked", "");
		let r = document.createElement("p");
		return Y(e.props, t), t.appendChild(n), t.appendChild(r), {
			dom: t,
			contentDOM: r
		};
	},
	runsBefore: ["bulletListItem"]
}, [t({
	key: "check-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Xn(e, "checkListItem"),
		"Mod-Shift-9": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "checkListItem",
				props: {}
			}), !0) : !1;
		}
	},
	inputRules: [{
		find: /^\s?\[\s*\]\s$/,
		replace() {
			return {
				type: "checkListItem",
				props: { checked: !1 }
			};
		}
	}, {
		find: /^\s?\[[Xx]\]\s$/,
		replace() {
			return {
				type: "checkListItem",
				props: { checked: !0 }
			};
		}
	}]
})]);
//#endregion
//#region src/blocks/ListItem/NumberedListItem/IndexingPlugin.ts
function nr(e, t, n, r) {
	let i = !!e.firstChild.attrs.start, a = N({
		posBeforeNode: t,
		node: e
	});
	if (!a.isBlockContainer) throw Error("impossible");
	let o = n.doc.resolve(a.bnBlock.beforePos).nodeBefore, s = o ? r.get(o) : void 0;
	if (s !== void 0) {
		let t = s + 1;
		return r.set(e, t), {
			index: t,
			isFirst: !1,
			hasStart: i
		};
	}
	let c = [{
		node: e,
		pos: t
	}], l = o, u = a.bnBlock.beforePos;
	for (; l && r.get(l) === void 0;) {
		let e = N({
			posBeforeNode: u - l.nodeSize,
			node: l
		});
		if (e.blockNoteType !== "numberedListItem") break;
		c.push({
			node: l,
			pos: u - l.nodeSize
		});
		let t = n.doc.resolve(e.bnBlock.beforePos).nodeBefore;
		u = e.bnBlock.beforePos, l = t;
	}
	let d, f, p = c[c.length - 1], m = N({
		posBeforeNode: p.pos,
		node: p.node
	});
	if (!m.isBlockContainer) throw Error("impossible");
	let h = n.doc.resolve(m.bnBlock.beforePos).nodeBefore, g = h ? r.get(h) : void 0;
	g === void 0 ? (d = (p.node.firstChild.attrs.start || 1) - 1, f = !0) : (d = g, f = !1);
	for (let e = c.length - 1; e >= 0; e--) {
		let t = c[e];
		f && e < c.length - 1 && (f = !1), d++, r.set(t.node, d);
	}
	return {
		index: d,
		isFirst: c.length === 1 ? f || g === void 0 : !1,
		hasStart: i
	};
}
function rr(e, t) {
	let n = /* @__PURE__ */ new Map(), r = t.decorations.map(e.mapping, e.doc), i = e.changedRange();
	if (!i) return { decorations: r };
	let a = [], o = /* @__PURE__ */ new Set();
	e.doc.nodesBetween(i.from, e.doc.nodeSize - 2, (t, s, c) => {
		if (c && o.has(c)) return !1;
		if (t.type.name === "blockContainer" && t.firstChild.type.name === "numberedListItem") {
			let { index: l, isFirst: u, hasStart: d } = nr(t, s, e, n), f = e.doc.nodeAt(s + 1);
			if (r.find(s + 1, s + 1 + f.nodeSize, (e) => e.index === l && e.isFirst === u && e.hasStart === d).length === 0) a.push(be.node(s + 1, s + 1 + f.nodeSize, { "data-index": l.toString() }, {
				index: l,
				isFirst: u,
				hasStart: d
			}));
			else if (s >= i.to && c) return o.add(c), !1;
		}
	});
	let s = a.flatMap((e) => r.find(e.from, e.to));
	return { decorations: r.remove(s).add(e.doc, a) };
}
var ir = () => new ve({
	key: new ye("numbered-list-indexing-decorations"),
	state: {
		init(e, t) {
			return rr(t.tr, { decorations: xe.empty });
		},
		apply(e, t) {
			return !e.docChanged && t.decorations ? t : rr(e, t);
		}
	},
	props: { decorations(e) {
		return this.getState(e)?.decorations ?? xe.empty;
	} }
}), ar = A(() => ({
	type: "numberedListItem",
	propSchema: {
		...q,
		start: {
			default: void 0,
			type: "number"
		}
	},
	content: "inline"
})), or = j(ar, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName !== "LI") return;
		let t = e.parentElement;
		if (t !== null && (t.tagName === "OL" || t.tagName === "DIV" && t.parentElement?.tagName === "OL")) {
			let n = parseInt(t.getAttribute("start") || "1"), r = J(e);
			return e.previousElementSibling || n === 1 ? r : {
				...r,
				start: n
			};
		}
	},
	parseContent: ({ el: e, schema: t }) => Zn(e, t, "numberedListItem"),
	render() {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("p");
		return Y(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: n
		};
	}
}, [t({
	key: "numbered-list-item-shortcuts",
	inputRules: [{
		find: /^\s?(\d+)\.\s$/,
		replace({ match: e, editor: t }) {
			if (et(t.prosemirrorState).blockNoteType === "heading") return;
			let n = parseInt(e[1]);
			return {
				type: "numberedListItem",
				props: { start: n === 1 ? void 0 : n }
			};
		}
	}],
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Xn(e, "numberedListItem"),
		"Mod-Shift-7": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "numberedListItem",
				props: {}
			}), !0) : !1;
		}
	},
	prosemirrorPlugins: [ir()]
})]), sr = A(() => ({
	type: "toggleListItem",
	propSchema: { ...q },
	content: "inline"
})), cr = j(sr, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "DETAILS") return J(e);
		if (e.tagName === "LI") {
			let t = e.parentElement;
			if (t && (t.tagName === "UL" || t.tagName === "DIV" && t.parentElement?.tagName === "UL") && e.querySelector(":scope > details")) return J(e);
		}
	},
	parseContent: ({ el: e, schema: t }) => {
		let n = e.tagName === "DETAILS" ? e : e.querySelector(":scope > details");
		if (!n) throw Error("No details found in toggleListItem parseContent");
		return Nn(n, t, "toggleListItem");
	},
	runsBefore: ["bulletListItem"],
	render(e, t) {
		let n = document.createElement("p");
		return {
			...Fn(e, t, n),
			contentDOM: n
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("li"), n = document.createElement("details");
		n.setAttribute("open", "");
		let r = document.createElement("summary"), i = document.createElement("p");
		return r.appendChild(i), n.appendChild(r), Y(e.props, t), t.appendChild(n), {
			dom: t,
			contentDOM: i,
			childrenDOM: n
		};
	}
}, [t({
	key: "toggle-list-item-shortcuts",
	keyboardShortcuts: {
		Enter: ({ editor: e }) => Xn(e, "toggleListItem"),
		"Mod-Shift-6": ({ editor: e }) => {
			let t = e.getTextCursorPosition();
			return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
				type: "toggleListItem",
				props: {}
			}), !0) : !1;
		}
	}
})]), lr = A(() => ({
	type: "pageBreak",
	propSchema: {},
	content: "none"
})), ur = j(lr, {
	parse(e) {
		if (e.tagName === "DIV" && e.hasAttribute("data-page-break")) return {};
	},
	render() {
		let e = document.createElement("div");
		return e.setAttribute("data-page-break", ""), { dom: e };
	},
	toExternalHTML() {
		let e = document.createElement("div");
		return e.setAttribute("data-page-break", ""), { dom: e };
	}
}), dr = (e) => e.extend({ blockSpecs: { pageBreak: ur() } }), fr = A(() => ({
	type: "paragraph",
	propSchema: q,
	content: "inline"
})), pr = j(fr, {
	meta: { isolating: !1 },
	parse: (e) => {
		if (e.tagName === "P" && e.textContent?.trim()) return J(e);
	},
	render: () => {
		let e = document.createElement("p");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("p");
		return Y(e.props, t), {
			dom: t,
			contentDOM: t
		};
	},
	runsBefore: ["default", "heading"]
}, [t({
	key: "paragraph-shortcuts",
	keyboardShortcuts: { "Mod-Alt-0": ({ editor: e }) => {
		let t = e.getTextCursorPosition();
		return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
			type: "paragraph",
			props: {}
		}), !0) : !1;
	} }
})]), mr = A(() => ({
	type: "quote",
	propSchema: {
		backgroundColor: q.backgroundColor,
		textColor: q.textColor
	},
	content: "inline"
})), hr = j(mr, {
	meta: { isolating: !1 },
	parse(e) {
		if (e.tagName === "BLOCKQUOTE") {
			let { backgroundColor: t, textColor: n } = J(e);
			return {
				backgroundColor: t,
				textColor: n
			};
		}
	},
	render() {
		let e = document.createElement("blockquote");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML(e) {
		let t = document.createElement("blockquote");
		return Y(e.props, t), {
			dom: t,
			contentDOM: t
		};
	}
}, [t({
	key: "quote-block-shortcuts",
	keyboardShortcuts: { "Mod-Alt-q": ({ editor: e }) => {
		let t = e.getTextCursorPosition();
		return e.schema.blockSchema[t.block.type].content === "inline" ? (e.updateBlock(t.block, {
			type: "quote",
			props: {}
		}), !0) : !1;
	} },
	inputRules: [{
		find: RegExp("^>\\s$"),
		replace() {
			return {
				type: "quote",
				props: {}
			};
		}
	}, {
		find: RegExp("^\\p{Quotation_Mark}\\s$", "u"),
		replace() {
			return {
				type: "quote",
				props: {}
			};
		}
	}]
})]), gr = 120, _r = 31, vr = s.create({
	name: "BlockNoteTableExtension",
	addProseMirrorPlugins: () => [le({
		cellMinWidth: 35,
		defaultCellMinWidth: 120,
		View: null
	}), he()],
	addKeyboardShortcuts() {
		return {
			Enter: () => this.editor.state.selection.$head.parent.type.name === "tableParagraph" ? this.editor.commands.command(({ state: e, dispatch: t }) => {
				if (!de(e)) return !1;
				let n = pe(me(e), "vert", 1);
				return n ? (t && t(e.tr.setSelection(te.between(n, fe(n))).scrollIntoView()), !0) : !1;
			}) : !1,
			Backspace: () => {
				let e = this.editor.state.selection, t = e.empty, n = e.$head.parentOffset === 0, r = e.$head.node().type.name === "tableParagraph";
				return t && n && r;
			},
			Tab: () => this.editor.commands.command(({ state: e, dispatch: t, view: n }) => ue(1)(e, t, n)),
			"Shift-Tab": () => this.editor.commands.command(({ state: e, dispatch: t, view: n }) => ue(-1)(e, t, n))
		};
	},
	extendNodeSchema(e) {
		return { tableRole: d(g(e, "tableRole", {
			name: e.name,
			options: e.options,
			storage: e.storage
		})) };
	}
}), yr = { textColor: q.textColor }, br = u.create({
	name: "tableHeader",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "tableContent+",
	addAttributes() {
		return {
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("colwidth");
					return t ? t.split(",").map((e) => parseInt(e, 10)) : null;
				}
			}
		};
	},
	tableRole: "header_cell",
	isolating: !0,
	parseHTML() {
		return [{
			tag: "th",
			getContent: (e, t) => Tr(e, t)
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"th",
			v(this.options.HTMLAttributes, e),
			0
		];
	}
}), xr = u.create({
	name: "tableCell",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "tableContent+",
	addAttributes() {
		return {
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("colwidth");
					return t ? t.split(",").map((e) => parseInt(e, 10)) : null;
				}
			}
		};
	},
	tableRole: "cell",
	isolating: !0,
	parseHTML() {
		return [{
			tag: "td",
			getContent: (e, t) => Tr(e, t)
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"td",
			v(this.options.HTMLAttributes, e),
			0
		];
	}
}), Sr = u.create({
	name: "table",
	content: "tableRow+",
	group: "blockContent",
	tableRole: "table",
	marks: "deletion insertion modification",
	isolating: !0,
	parseHTML() {
		return [{ tag: "table" }];
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		let n = Ve(this.name, "table", {
			...this.options.domAttributes?.blockContent || {},
			...t
		}, this.options.domAttributes?.inlineContent || {}), r = document.createElement("colgroup");
		for (let t of e.children[0].children) if (t.attrs.colwidth) for (let e of t.attrs.colwidth) {
			let t = document.createElement("col");
			e && (t.style = `width: ${e}px`), r.appendChild(t);
		}
		else r.appendChild(document.createElement("col"));
		return n.dom.firstChild?.appendChild(r), n;
	},
	addNodeView() {
		return ({ node: e, HTMLAttributes: t }) => {
			class n extends ce {
				constructor(e, t, n) {
					super(e, t), this.node = e, this.cellMinWidth = t, this.blockContentHTMLAttributes = n;
					let r = document.createElement("div");
					r.className = D("bn-block-content", n.class), r.setAttribute("data-content-type", "table");
					for (let [e, t] of Object.entries(n)) e !== "class" && r.setAttribute(e, t);
					let i = this.dom, a = document.createElement("div");
					a.className = "tableWrapper-inner", a.appendChild(i.firstChild), i.appendChild(a), r.appendChild(i);
					let o = document.createElement("div");
					o.className = "table-widgets-container", o.style.position = "relative", i.appendChild(o), this.dom = r;
				}
				ignoreMutation(e) {
					return !e.target.closest(".tableWrapper-inner") || super.ignoreMutation(e);
				}
				update(e) {
					if (!super.update(e)) return !1;
					for (let [t, n] of Object.entries(yr)) {
						let r = O(t), i = e.attrs[t];
						i === n.default ? this.dom.removeAttribute(r) : this.dom.setAttribute(r, String(i));
					}
					return !0;
				}
			}
			return new n(e, 120, {
				...this.options.domAttributes?.blockContent || {},
				...t
			});
		};
	}
}), Cr = u.create({
	name: "tableParagraph",
	group: "tableContent",
	content: "inline*",
	parseHTML() {
		return [{
			tag: "p",
			getAttrs: (e) => {
				if (typeof e == "string" || !e.textContent || !e.closest("[data-content-type]")) return !1;
				let t = e.parentElement;
				return t === null ? !1 : t.tagName === "TD" || t.tagName === "TH" ? {} : !1;
			},
			node: "tableParagraph"
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"p",
			e,
			0
		];
	}
}), wr = u.create({
	name: "tableRow",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	content: "(tableCell | tableHeader)+",
	tableRole: "row",
	marks: "deletion insertion modification",
	parseHTML() {
		return [{ tag: "tr" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"tr",
			v(this.options.HTMLAttributes, e),
			0
		];
	}
});
function Tr(e, t) {
	let i = n.fromSchema(t).parse(e, { topNode: t.nodes.blockGroup.create() }), a = [];
	return i.content.descendants((e) => {
		if (e.isInline) return a.push(e), !1;
	}), r.fromArray(a);
}
var Er = () => Je({
	node: Sr,
	type: "table",
	content: "table"
}, yr, [t({
	key: "table-extensions",
	tiptapExtensions: [
		vr,
		Cr,
		br,
		xr,
		wr
	]
}), t({
	key: "table-keyboard-delete",
	keyboardShortcuts: { Backspace: ({ editor: e }) => {
		if (!(e.prosemirrorState.selection instanceof oe)) return !1;
		let t = e.getTextCursorPosition().block, n = t.content, r = 0;
		for (let e of n.rows) for (let t of e.cells) {
			if ("type" in t && t.content.length > 0 || !("type" in t) && t.length > 0) return !1;
			r++;
		}
		let i = 0;
		return e.prosemirrorState.selection.forEachCell(() => {
			i++;
		}), i < r ? !1 : (e.transact(() => {
			(e.getPrevBlock(t) || e.getNextBlock(t)) && e.setTextCursorPosition(t), e.removeBlocks([t]);
		}), !0);
	} }
})]), Dr = (e) => ({
	url: e.src || void 0,
	previewWidth: e.width || void 0,
	name: e.getAttribute("data-name") || void 0
}), Or = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z\"></path></svg>", kr = A((e) => ({
	type: "video",
	propSchema: {
		textAlignment: q.textAlignment,
		backgroundColor: q.backgroundColor,
		name: { default: "" },
		url: { default: "" },
		caption: { default: "" },
		showPreview: { default: !0 },
		previewWidth: {
			default: void 0,
			type: "number"
		}
	},
	content: "none"
})), Ar = (e) => (e) => {
	if (e.tagName === "VIDEO") {
		if (e.closest("figure")) return;
		let { backgroundColor: t } = J(e);
		return {
			...Dr(e),
			backgroundColor: t
		};
	}
	if (e.tagName === "FIGURE") {
		let t = sn(e, "video");
		if (!t) return;
		let { targetElement: n, caption: r } = t, { backgroundColor: i } = J(e);
		return {
			...Dr(n),
			backgroundColor: i,
			caption: r
		};
	}
}, jr = j(kr, (e) => ({
	meta: { fileBlockAccept: ["video/*"] },
	parse: Ar(e),
	render(t, n) {
		let r = document.createElement("div");
		r.innerHTML = e.icon ?? "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z\"></path></svg>";
		let i = document.createElement("div");
		i.className = "bn-visual-media-wrapper";
		let a = document.createElement("video");
		return a.className = "bn-visual-media", n.resolveFileUrl ? n.resolveFileUrl(t.props.url).then((e) => {
			a.src = e;
		}) : a.src = t.props.url, a.controls = !0, a.contentEditable = "false", a.draggable = !1, a.width = t.props.previewWidth, i.appendChild(a), Bn(t, n, { dom: i }, i, r.firstElementChild);
	},
	toExternalHTML(e) {
		if (!e.props.url) return { dom: document.createElement("video") };
		let t;
		return e.props.showPreview ? (t = document.createElement("video"), t.src = e.props.url, e.props.previewWidth && (t.width = e.props.previewWidth)) : (t = document.createElement("a"), t.href = e.props.url, t.textContent = e.props.name || e.props.url), e.props.caption ? e.props.showPreview ? fn(t, e.props.caption) : pn(t, e.props.caption) : { dom: t };
	},
	runsBefore: ["file"]
})), Mr = async (e) => {
	let t = new FormData();
	return t.append("file", e), (await (await fetch("https://tmpfiles.org/api/v1/upload", {
		method: "POST",
		body: t
	})).json()).data.url.replace("tmpfiles.org/", "tmpfiles.org/dl/");
};
//#endregion
//#region src/blocks/defaultBlockTypeGuards.ts
function Z(e, t, n) {
	if (!(t in e.schema.blockSpecs)) return !1;
	if (!n) return !0;
	for (let [r, i] of Object.entries(n)) {
		if (!(r in e.schema.blockSpecs[t].config.propSchema)) return !1;
		if (typeof i == "string") {
			if (e.schema.blockSpecs[t].config.propSchema[r].default !== void 0 && typeof e.schema.blockSpecs[t].config.propSchema[r].default !== i || e.schema.blockSpecs[t].config.propSchema[r].type !== void 0 && e.schema.blockSpecs[t].config.propSchema[r].type !== i) return !1;
		} else {
			if (e.schema.blockSpecs[t].config.propSchema[r].default !== i.default || e.schema.blockSpecs[t].config.propSchema[r].default === void 0 && i.default === void 0 && e.schema.blockSpecs[t].config.propSchema[r].type !== i.type || typeof e.schema.blockSpecs[t].config.propSchema[r].values != typeof i.values) return !1;
			if (typeof e.schema.blockSpecs[t].config.propSchema[r].values == "object" && typeof i.values == "object") {
				for (let n of i.values) if (!e.schema.blockSpecs[t].config.propSchema[r].values.includes(n)) return !1;
			}
		}
	}
	return !0;
}
function Nr(e, t, n, r) {
	return Z(t, n, r) && e.type === n;
}
function Pr(e) {
	return e instanceof oe;
}
//#endregion
//#region src/api/positionMapping.ts
var Fr = /* @__PURE__ */ new Map();
function Ir(e) {
	if (Fr.has(e)) return Fr.get(e);
	let t = new a();
	return e._tiptapEditor.on("transaction", ({ transaction: e }) => {
		t.appendMapping(e.mapping);
	}), e._tiptapEditor.on("destroy", () => {
		Fr.delete(e);
	}), Fr.set(e, t), t;
}
function Lr(e, t, n = "left") {
	let r = Ee.getState(e.prosemirrorState);
	if (!r) {
		let r = Ir(e), i = r.maps.length;
		return () => r.slice(i).map(t, n === "left" ? -1 : 1);
	}
	let i = we(t + (n === "right" ? 1 : -1), r.binding.type, r.binding.mapping);
	return () => {
		let t = Ee.getState(e.prosemirrorState), r = Te(t.doc, t.binding.type, i, t.binding.mapping);
		if (r === null) throw Error("Position not found, cannot track positions");
		return r + (n === "right" ? -1 : 1);
	};
}
//#endregion
//#region src/extensions/SuggestionMenu/SuggestionMenu.ts
var Rr = m((e) => e.type.name === "blockContainer"), zr = class {
	state;
	emitUpdate;
	rootEl;
	pluginState;
	constructor(e, t, n) {
		this.editor = e, this.pluginState = void 0, this.emitUpdate = (e) => {
			if (!this.state) throw Error("Attempting to update uninitialized suggestions menu");
			t(e, {
				...this.state,
				ignoreQueryLength: this.pluginState?.ignoreQueryLength
			});
		}, this.rootEl = n.root, this.rootEl?.addEventListener("scroll", this.handleScroll, !0);
	}
	handleScroll = () => {
		if (this.state?.show) {
			let e = this.rootEl?.querySelector(`[data-decoration-id="${this.pluginState.decorationId}"]`);
			if (!e) return;
			this.state.referencePos = e.getBoundingClientRect().toJSON(), this.emitUpdate(this.pluginState.triggerCharacter);
		}
	};
	update(e, t) {
		let n = Q.getState(t), r = Q.getState(e.state), i = n === void 0 && r !== void 0, a = n !== void 0 && r === void 0;
		if (!i && !(n !== void 0 && r !== void 0) && !a) return;
		if (this.pluginState = a ? n : r, a || !this.editor.isEditable) {
			this.state && (this.state.show = !1), this.emitUpdate(this.pluginState.triggerCharacter);
			return;
		}
		let o = this.rootEl?.querySelector(`[data-decoration-id="${this.pluginState.decorationId}"]`);
		this.editor.isEditable && o && (this.state = {
			show: !0,
			referencePos: o.getBoundingClientRect().toJSON(),
			query: this.pluginState.query
		}, this.emitUpdate(this.pluginState.triggerCharacter));
	}
	destroy() {
		this.rootEl?.removeEventListener("scroll", this.handleScroll, !0);
	}
	closeMenu = () => {
		this.editor.transact((e) => e.setMeta(Q, null));
	};
	clearQuery = () => {
		this.pluginState !== void 0 && this.editor._tiptapEditor.chain().focus().deleteRange({
			from: this.pluginState.queryStartPos() - (this.pluginState.deleteTriggerCharacter ? this.pluginState.triggerCharacter.length : 0),
			to: this.editor.transact((e) => e.selection.from)
		}).run();
	};
}, Q = new ee("SuggestionMenuPlugin"), Br = t(({ editor: t }) => {
	let n = /* @__PURE__ */ new Map(), r, i = e(void 0);
	return {
		key: "suggestionMenu",
		store: i,
		addSuggestionMenu: (e) => {
			n.set(e.triggerCharacter, e);
		},
		removeSuggestionMenu: (e) => {
			n.delete(e);
		},
		closeMenu: () => {
			r?.closeMenu();
		},
		clearQuery: () => {
			r?.clearQuery();
		},
		shown: () => r?.state?.show || !1,
		openSuggestionMenu: (e, n) => {
			t.headless || (t.focus(), t.transact((t) => {
				n?.deleteTriggerCharacter && t.insertText(e), t.scrollIntoView().setMeta(Q, {
					triggerCharacter: e,
					deleteTriggerCharacter: n?.deleteTriggerCharacter || !1,
					ignoreQueryLength: n?.ignoreQueryLength || !1
				});
			}));
		},
		prosemirrorPlugins: [new y({
			key: Q,
			view: (e) => (r = new zr(t, (e, t) => {
				i.setState({
					...t,
					triggerCharacter: e
				});
			}, e), r),
			state: {
				init() {},
				apply: (e, n, i, a) => {
					if (e.selection.$from.parent.type.spec.code) return n;
					let o = e.getMeta(Q);
					if (typeof o == "object" && o) {
						n && r?.closeMenu();
						let e = Lr(t, a.selection.from - o.triggerCharacter.length);
						return {
							triggerCharacter: o.triggerCharacter,
							deleteTriggerCharacter: o.deleteTriggerCharacter !== !1,
							queryStartPos: () => e() + o.triggerCharacter.length,
							query: "",
							decorationId: `id_${Math.floor(Math.random() * 4294967295)}`,
							ignoreQueryLength: o?.ignoreQueryLength
						};
					}
					if (n === void 0) return n;
					if (a.selection.from !== a.selection.to || o === null || e.getMeta("focus") || e.getMeta("blur") || e.getMeta("pointer") || n.triggerCharacter !== void 0 && a.selection.from < n.queryStartPos() || !a.selection.$from.sameParent(a.doc.resolve(n.queryStartPos()))) return;
					let s = { ...n };
					return s.query = a.doc.textBetween(n.queryStartPos(), a.selection.from), s;
				}
			},
			props: {
				handleTextInput(e, t, r, i) {
					if (t === r) {
						let r = e.state.doc;
						for (let [a, o] of n) {
							let n = a.length > 1 ? r.textBetween(t - a.length, t) + i : i;
							if (a === n) {
								if (o.shouldOpen && !o.shouldOpen(e.state.tr)) continue;
								return e.dispatch(e.state.tr.insertText(i)), e.dispatch(e.state.tr.setMeta(Q, { triggerCharacter: n }).scrollIntoView()), !0;
							}
						}
					}
					return !1;
				},
				decorations(e) {
					let t = this.getState(e);
					if (t === void 0) return null;
					if (!t.deleteTriggerCharacter) {
						let n = Rr(e.selection);
						if (n) return Ce.create(e.doc, [Se.node(n.pos, n.pos + n.node.nodeSize, {
							nodeName: "span",
							class: "bn-suggestion-decorator",
							"data-decoration-id": t.decorationId
						})]);
					}
					return Ce.create(e.doc, [Se.inline(t.queryStartPos() - t.triggerCharacter.length, t.queryStartPos(), {
						nodeName: "span",
						class: "bn-suggestion-decorator",
						"data-decoration-id": t.decorationId
					})]);
				}
			}
		})]
	};
});
//#endregion
//#region src/extensions/SuggestionMenu/getDefaultSlashMenuItems.ts
function Vr(e) {
	let t = e.getTextCursorPosition().block, n = e.schema.blockSchema[t.type].content;
	for (; n === "none";) {
		if (t = e.getTextCursorPosition().nextBlock, t === void 0) return;
		n = e.schema.blockSchema[t.type].content, e.setTextCursorPosition(t, "end");
	}
}
function $(e, t) {
	let n = e.getTextCursorPosition().block;
	if (n.content === void 0) throw Error("Slash Menu open in a block that doesn't contain content.");
	let r;
	return Array.isArray(n.content) && (n.content.length === 1 && b(n.content[0]) && n.content[0].type === "text" && n.content[0].text === "/" || n.content.length === 0) ? (r = e.updateBlock(n, t), e.setTextCursorPosition(r)) : (r = e.insertBlocks([t], n, "after")[0], e.setTextCursorPosition(e.getTextCursorPosition().nextBlock)), Vr(e), r;
}
function Hr(e) {
	let t = [];
	return Z(e, "heading", { level: "number" }) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e <= 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: { level: n }
				});
			},
			badge: E(`Mod-Alt-${n}`),
			key: n === 1 ? "heading" : `heading_${n}`,
			...e.dictionary.slash_menu[n === 1 ? "heading" : `heading_${n}`]
		});
	}), Z(e, "quote") && t.push({
		onItemClick: () => {
			$(e, { type: "quote" });
		},
		key: "quote",
		...e.dictionary.slash_menu.quote
	}), Z(e, "toggleListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "toggleListItem" });
		},
		badge: E("Mod-Shift-6"),
		key: "toggle_list",
		...e.dictionary.slash_menu.toggle_list
	}), Z(e, "numberedListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "numberedListItem" });
		},
		badge: E("Mod-Shift-7"),
		key: "numbered_list",
		...e.dictionary.slash_menu.numbered_list
	}), Z(e, "bulletListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "bulletListItem" });
		},
		badge: E("Mod-Shift-8"),
		key: "bullet_list",
		...e.dictionary.slash_menu.bullet_list
	}), Z(e, "checkListItem") && t.push({
		onItemClick: () => {
			$(e, { type: "checkListItem" });
		},
		badge: E("Mod-Shift-9"),
		key: "check_list",
		...e.dictionary.slash_menu.check_list
	}), Z(e, "paragraph") && t.push({
		onItemClick: () => {
			$(e, { type: "paragraph" });
		},
		badge: E("Mod-Alt-0"),
		key: "paragraph",
		...e.dictionary.slash_menu.paragraph
	}), Z(e, "codeBlock") && t.push({
		onItemClick: () => {
			$(e, { type: "codeBlock" });
		},
		badge: E("Mod-Alt-c"),
		key: "code_block",
		...e.dictionary.slash_menu.code_block
	}), Z(e, "divider") && t.push({
		onItemClick: () => {
			$(e, { type: "divider" });
		},
		key: "divider",
		...e.dictionary.slash_menu.divider
	}), Z(e, "table") && t.push({
		onItemClick: () => {
			$(e, {
				type: "table",
				content: {
					type: "tableContent",
					rows: [{ cells: [
						"",
						"",
						""
					] }, { cells: [
						"",
						"",
						""
					] }]
				}
			});
		},
		badge: void 0,
		key: "table",
		...e.dictionary.slash_menu.table
	}), Z(e, "image", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "image" });
			e.getExtension(X)?.showMenu(t.id);
		},
		key: "image",
		...e.dictionary.slash_menu.image
	}), Z(e, "video", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "video" });
			e.getExtension(X)?.showMenu(t.id);
		},
		key: "video",
		...e.dictionary.slash_menu.video
	}), Z(e, "audio", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "audio" });
			e.getExtension(X)?.showMenu(t.id);
		},
		key: "audio",
		...e.dictionary.slash_menu.audio
	}), Z(e, "file", { url: "string" }) && t.push({
		onItemClick: () => {
			let t = $(e, { type: "file" });
			e.getExtension(X)?.showMenu(t.id);
		},
		key: "file",
		...e.dictionary.slash_menu.file
	}), Z(e, "heading", {
		level: "number",
		isToggleable: "boolean"
	}) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e <= 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: {
						level: n,
						isToggleable: !0
					}
				});
			},
			key: n === 1 ? "toggle_heading" : `toggle_heading_${n}`,
			...e.dictionary.slash_menu[n === 1 ? "toggle_heading" : `toggle_heading_${n}`]
		});
	}), Z(e, "heading", { level: "number" }) && (e.schema.blockSchema.heading.propSchema.level.values || []).filter((e) => e > 3).forEach((n) => {
		t.push({
			onItemClick: () => {
				$(e, {
					type: "heading",
					props: { level: n }
				});
			},
			badge: E(`Mod-Alt-${n}`),
			key: `heading_${n}`,
			...e.dictionary.slash_menu[`heading_${n}`]
		});
	}), t.push({
		onItemClick: () => {
			e.getExtension(Br)?.openSuggestionMenu(":", {
				deleteTriggerCharacter: !0,
				ignoreQueryLength: !0
			});
		},
		key: "emoji",
		...e.dictionary.slash_menu.emoji
	}), t;
}
function Ur(e, t) {
	return e.filter(({ title: e, aliases: n }) => e.toLowerCase().includes(t.toLowerCase()) || n && n.filter((e) => e.toLowerCase().includes(t.toLowerCase())).length !== 0);
}
//#endregion
//#region src/blocks/PageBreak/getPageBreakSlashMenuItems.ts
function Wr(e) {
	return "pageBreak" in e.schema.blockSchema;
}
function Gr(e) {
	let t = [];
	return Wr(e) && t.push({
		...e.dictionary.slash_menu.page_break,
		onItemClick: () => {
			$(e, { type: "pageBreak" });
		},
		key: "page_break"
	}), t;
}
//#endregion
//#region src/blocks/defaultBlocks.ts
var Kr = {
	audio: bn(),
	bulletListItem: $n(),
	checkListItem: tr(),
	codeBlock: Tn(),
	divider: On(),
	file: Mn(),
	heading: zn(),
	image: qn(),
	numberedListItem: or(),
	paragraph: pr(),
	quote: hr(),
	table: Er(),
	toggleListItem: cr(),
	video: jr()
}, qr = bt({
	type: "textColor",
	propSchema: "string"
}, {
	render: () => {
		let e = document.createElement("span");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("span");
		return e !== q.textColor.default && (t.style.color = e in K ? K[e].text : e), {
			dom: t,
			contentDOM: t
		};
	},
	parse: (e) => {
		if (e.tagName === "SPAN" && e.style.color) return e.style.color;
	}
}), Jr = bt({
	type: "backgroundColor",
	propSchema: "string"
}, {
	render: () => {
		let e = document.createElement("span");
		return {
			dom: e,
			contentDOM: e
		};
	},
	toExternalHTML: (e) => {
		let t = document.createElement("span");
		return e !== q.backgroundColor.default && (t.style.backgroundColor = e in K ? K[e].background : e), {
			dom: t,
			contentDOM: t
		};
	},
	parse: (e) => {
		if (e.tagName === "SPAN" && e.style.backgroundColor) return e.style.backgroundColor;
	}
}), Yr = {
	bold: z(De, "boolean"),
	italic: z(ke, "boolean"),
	underline: z(je, "boolean"),
	strike: z(Ae, "boolean"),
	code: z(Oe.extend({ addInputRules() {
		return [_({
			find: /(^|[^`])`([^`]+)`(?!`)$/,
			type: this.type
		}), new c({
			find: /(^|[^`])`([^`]+)`(?!`) $/,
			handler: ({ state: e, range: t, match: n }) => {
				let { tr: r, schema: i } = e, a = n[1], o = n[2];
				r.replaceWith(t.from + a.length, t.to, [i.text(o, [this.type.create()]), i.text(" ")]);
			}
		})];
	} }), "boolean"),
	textColor: qr,
	backgroundColor: Jr
}, Xr = vt(Yr), Zr = {
	text: {
		config: "text",
		implementation: {}
	},
	link: {
		config: "link",
		implementation: {}
	}
}, Qr = ht(Zr), $r = class e extends At {
	static create(t) {
		return new e({
			blockSpecs: t?.blockSpecs ?? Kr,
			inlineContentSpecs: t?.inlineContentSpecs ?? Zr,
			styleSpecs: t?.styleSpecs ?? Yr
		});
	}
};
//#endregion
export { Mn as $, pt as $t, lr as A, Ge as An, Kt as At, $n as B, w as Bn, It as Bt, yr as C, Xe as Cn, $t as Ct, hr as D, k as Dn, Yt as Dt, mr as E, Ke as En, Jt as Et, ar as F, ze as Fn, Rt as Ft, Wn as G, Fe as Gn, R as Gt, Hn as H, S as Hn, Ot as Ht, or as I, Be as In, Pt as It, Rn as J, Pe as Jn, vt as Jt, Gn as K, Ie as Kn, _t as Kt, tr as L, D as Ln, Nt as Lt, dr as M, He as Mn, Ht as Mt, sr as N, Ue as Nn, Vt as Nt, fr as O, O as On, W as Ot, cr as P, E as Pn, Bt as Pt, An as Q, mt as Qt, er as R, T as Rn, jt as Rt, Er as S, j as Sn, en as St, gr as T, qe as Tn, G as Tt, Un as U, C as Un, bt as Ut, Jn as V, Le as Vn, At as Vt, qn as W, x as Wn, yt as Wt, Fn as X, dt as Xt, zn as Y, gt as Yt, Pn as Z, ft as Zt, Mr as _, Qe as _n, on as _t, Xr as a, ct as an, En as at, jr as b, Ye as bn, nn as bt, Gr as c, rt as cn, vn as ct, $ as d, P as dn, bn as dt, ht as en, jn as et, Br as f, F as fn, mn as ft, Pr as g, tt as gn, rn as gt, Z as h, et as hn, q as ht, Zr as i, L as in, Tn as it, ur as j, Ve as jn, zt as jt, pr as k, We as kn, U as kt, Ur as l, it as ln, yn as lt, Nr as m, $e as mn, Y as mt, Kr as n, st as nn, On as nt, Yr as o, ut as on, hn as ot, Lr as p, N as pn, X as pt, Kn as q, b as qn, z as qt, Qr as r, lt as rn, wn as rt, Wr as s, ot as sn, _n as st, $r as t, I as tn, Dn as tt, Hr as u, at as un, gn as ut, Or as v, M as vn, an as vt, _r as w, Je as wn, Xt as wt, Ar as x, A as xn, K as xt, kr as y, Ze as yn, J as yt, Qn as z, Re as zn, Ft as zt };

//# sourceMappingURL=blocks-CU0VONcw.js.map